import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import ReactDOM from "react-dom";
import { useLang } from "../hooks";

// ─── SVG Icons (Monochrome) ──────────────────────────────────────────────────
const IconChart    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>;
const IconCalendar = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconTag      = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>;
const IconDownload = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const IconPrint    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>;
const IconBolt     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const IconAlert    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
const IconCheck    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IconX        = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconEdit     = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IconTrash    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>;
const IconStamp    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 17h18v4H3z"/><path d="M10 13V7a2 2 0 1 1 4 0v6"/><rect x="7" y="13" width="10" height="4" rx="1"/></svg>;
const IconPaperclip= () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>;

// ─── constants ───────────────────────────────────────────────────────────────
const BASE_URL = process.env.REACT_APP_API_BASE_URL 
const UPLOADS_BASE_URL = process.env.REACT_APP_UPLOADS_API_BASE_URL || "";
const NUM_COL_WIDTH = 148;
const ERP_PRIMARY = "#334155";
const ERP_PRIMARY_DARK = "#1f2937";

async function uploadFileToServer(file) {
  if (!file) return null;
  if (!UPLOADS_BASE_URL) throw new Error("Uploads server is not configured");

  const formData = new FormData();
  formData.append("myfile", file, file.name);

  const response = await fetch(`${UPLOADS_BASE_URL}/vatfilingreport`, {
    method: "POST",
    body: formData,
  });
  const result = await response.json();
  const location = result?.data?.location;

  if (!response.ok || !location) {
    throw new Error(result?.message || "File upload failed");
  }

  return location;
}

const PERIOD_OPTIONS = [
  { label: "هذا الشهر",            labelEn: "This Month",       value: "this_month"   },
  { label: "الشهر الماضي",         labelEn: "Last Month",       value: "last_month"   },
  { label: "ربع السنة الحالي",     labelEn: "This Quarter",     value: "this_quarter" },
  { label: "ربع السنة الماضي",     labelEn: "Last Quarter",     value: "last_quarter" },
  { label: "السنة المالية الحالية",labelEn: "This Fiscal Year", value: "this_year"    },
  { label: "السنة المالية الماضية",labelEn: "Last Fiscal Year", value: "last_year"    },
  { label: "تاريخ يدوي",           labelEn: "Custom Date",      value: "custom"       },
];

// ─── date helpers ─────────────────────────────────────────────────────────────
const toISO = (d) => {
  const yy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
};
function quarterRange(year, q) {
  const startMonth = [0, 3, 6, 9][q - 1];
  const endMonth   = [2, 5, 8, 11][q - 1];
  return { start: new Date(year, startMonth, 1), end: new Date(year, endMonth + 1, 0) };
}
function computeDateRange(period) {
  const now = new Date();
  const y = now.getFullYear(), m = now.getMonth(), q = Math.floor(m / 3) + 1;
  switch (period) {
    case "this_month":   return { from: toISO(new Date(y, m, 1)),     to: toISO(new Date(y, m + 1, 0)) };
    case "last_month":   return { from: toISO(new Date(y, m - 1, 1)), to: toISO(new Date(y, m, 0))     };
    case "this_quarter": { const r = quarterRange(y, q);              return { from: toISO(r.start), to: toISO(r.end) }; }
    case "last_quarter": { const pq=q===1?4:q-1, py=q===1?y-1:y; const r=quarterRange(py,pq); return { from: toISO(r.start), to: toISO(r.end) }; }
    case "this_year":    return { from: `${y}-01-01`,   to: `${y}-12-31`   };
    case "last_year":    return { from: `${y-1}-01-01`, to: `${y-1}-12-31` };
    default:             return { from: toISO(new Date(y, m, 1)),     to: toISO(new Date(y, m + 1, 0)) };
  }
}

// ─── localStorage helpers ─────────────────────────────────────────────────────
function getTenantId()  { try { return JSON.parse(localStorage.getItem("tenant"))?._id ?? null; } catch { return null; } }
function getCompanyId() { try { return JSON.parse(localStorage.getItem("apps-web-absat:selectedCompany"))?.value ?? null; } catch { return null; } }
function getBranchId()  { try { return JSON.parse(localStorage.getItem("apps-web-absat:selectedBranch"))?.value ?? null; } catch { return null; } }
function getUserCurrencyCode() {
  try {
    const tenant = JSON.parse(localStorage.getItem("tenant"));
    const user = JSON.parse(localStorage.getItem("user"));
    const selectedCompanyId = JSON.parse(localStorage.getItem("apps-web-absat:selectedCompany"))?.value;
    const companies = Array.isArray(tenant?.companies) ? tenant.companies : [];
    const companyId = selectedCompanyId || user?.company_id;
    const company = companies.find(c => String(c?._id) === String(companyId));

    let code = String(company?.currency || "").trim();
    if (!code) {
      const invoiceSettings = Array.isArray(company?.settings?.invoice) ? company.settings.invoice : [];
      const invoiceCurrency = invoiceSettings.find(
        (s) => s?.name === "INV_CURRENCY" || s?.settingName === "INV_CURRENCY"
      )?.value;
      code = String(invoiceCurrency || "").trim();
    }

    if (!code || code.toUpperCase() === "R") return "SAR";
    return code.toUpperCase();
  } catch {
    return "SAR";
  }
}
function getCurrencyDisplay(code, isAr) {
  const normalized = String(code || "SAR").toUpperCase();
  const names = {
    SAR: { ar: "ريال سعودي", en: "Saudi Riyal" },
    USD: { ar: "دولار أمريكي", en: "US Dollar" },
    EUR: { ar: "يورو", en: "Euro" },
    AED: { ar: "درهم إماراتي", en: "UAE Dirham" },
    EGP: { ar: "جنيه مصري", en: "Egyptian Pound" },
  };
  const name = names[normalized]?.[isAr ? "ar" : "en"] || normalized;
  return `${name} (${normalized})`;
}

function normalizeTax(t, lang) {
  const nameAr = t.tax_name_ar?.trim() || String(t.id);
  const nameEn = t.tax_name_en?.trim() || String(t.id);
  const pct    = t.tax_value != null ? ` ${t.tax_value}%` : "";
  return {
    id:      t.id,
    labelAr: `ضريبة ${nameAr}${pct}`,
    labelEn: `VAT ${nameEn}${pct}`,
    label:   lang === "ar" ? `ضريبة ${nameAr}${pct}` : `VAT ${nameEn}${pct}`,
    value:   t.tax_value,
    raw:     t,
  };
}
const fmt = (v) =>
  Number(v || 0).toLocaleString("en-SA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
function displayDate(isoStr) {
  if (!isoStr) return "";
  const [y, mo, d] = String(isoStr).trim().split("-");
  return `${d}/${mo}/${y}`;
}

function normalizeAttachmentUrl(url = "") {
  return String(url ?? "").replace(/\\\//g, "/").trim();
}

function isPdfFile(url = "") {
  return /\.pdf($|\?)/i.test(normalizeAttachmentUrl(url));
}

function isImageFile(url = "") {
  return /\.(png|jpe?g|gif|webp|svg|bmp|tiff?)($|\?)/i.test(normalizeAttachmentUrl(url));
}

function trimOrEmpty(v) {
  return String(v ?? "").trim();
}

function trimOrNull(v) {
  const s = String(v ?? "").trim();
  return s === "" ? null : s;
}

function normalizeCsvIds(v = "") {
  return String(v ?? "")
    .split(",")
    .map(x => trimOrEmpty(x).replace(/^['"]+|['"]+$/g, ""))
    .filter(Boolean)
    .join(",");
}

function getFilingId(v) {
  return trimOrEmpty(v?.id ?? v?._id ?? v);
}

async function parseResponseSafe(res) {
  const raw = await res.text();
  let json = null;
  try { json = JSON.parse(raw); } catch {}
  return { raw, json };
}

async function putTaxReportUpdate(id, payload) {
  const cleanId = trimOrEmpty(id);
  const urls = [
    `${BASE_URL}/sales/zatca-tax-report/update/${cleanId}`,
    `${BASE_URL}/sales/zatca-tax-report/${cleanId}`,
  ];
  let last = null;
  for (const url of urls) {
    const res = await fetch(url, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const parsed = await parseResponseSafe(res);
    const ok = parsed.json?.status === 1 || res.ok;
    if (ok) return { res, ...parsed };
    last = { res, ...parsed };
    if (![404, 405].includes(res.status)) break;
  }
  return last;
}

function FilePreviewPopup({ fileUrl, title, isAr, onClose }) {
  const normalizedFileUrl = normalizeAttachmentUrl(fileUrl);
  const modal = (
    <div
      onClick={onClose}
      style={{
        position:"fixed",inset:0,zIndex:100000,
        background:"rgba(10,18,35,.88)",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        overflow:"hidden",
        cursor:"zoom-out",
      }}
    >
      {isImageFile(normalizedFileUrl) && (
        <img
          onClick={e=>e.stopPropagation()}
          src={normalizedFileUrl}
          alt="preview"
          style={{
            display:"block",
            maxWidth:"90vw",
            maxHeight:"90vh",
            width:"auto",
            height:"auto",
            objectFit:"contain",
            borderRadius:10,
            boxShadow:"0 8px 48px rgba(0,0,0,.7)",
            cursor:"default",
          }}
        />
      )}
      {!isImageFile(normalizedFileUrl) && (
        <div
          onClick={e=>e.stopPropagation()}
          style={{
            width:"min(92vw,860px)",
            height:"calc(100vh - 60px)",
            display:"flex",
            flexDirection:"column",
            borderRadius:10,
            overflow:"hidden",
            boxShadow:"0 8px 48px rgba(0,0,0,.6)",
          }}
        >
          <div style={{padding:"10px 16px",background:"#251658",color:"#fff",fontWeight:700,fontSize:13,flexShrink:0,display:"flex",alignItems:"center",gap:8,direction:isAr?"rtl":"ltr"}}>
            <IconPaperclip/>
            <span style={{flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{title||(isAr?"معاينة الملف":"File Preview")}</span>
          </div>
          <iframe title="file-preview" src={normalizedFileUrl} style={{flex:1,border:"none",background:"#fff",width:"100%"}} />
        </div>
      )}
    </div>
  );
  return ReactDOM.createPortal(modal, document.body);
}

// ─── ZatcaFilingDetailPopup ───────────────────────────────────────────────────
function ZatcaFilingDetailPopup({
  filing,
  isAr,
  onClose,
  onDeleted,
  onUpdated,
  dateRange,
  tenantId,
  companyId,
  salesInvoices,
  purchasesInvoices,
  periodLabel,
  salesData,
  purchasesData,
  taxRateLabel,
}) {
  const [editMode,      setEditMode]      = useState(false);
  const [editStep,      setEditStep]      = useState(1); // 1 or 2 (within edit mode)
  const [salesFileConfirm, setSalesFileConfirm] = useState(null);
  const [paidFile,      setPaidFile]      = useState(null);
  const [salesIds,      setSalesIds]      = useState(normalizeCsvIds(filing.sales_invoices_ids ?? ""));
  const [purchasesIds,  setPurchasesIds]  = useState(normalizeCsvIds(filing.purchases_invoices_ids ?? ""));
  const [saving,        setSaving]        = useState(false);
  const [deleting,      setDeleting]      = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [previewFile,   setPreviewFile]   = useState(null);
  const [previewTitle,  setPreviewTitle]  = useState("");
  const [err,           setErr]           = useState(null);
  const [showEditDeclaration, setShowEditDeclaration] = useState(false);
  const [showViewDeclaration, setShowViewDeclaration] = useState(false);

  const attachConfirmUrl = normalizeAttachmentUrl(filing.attach_confirm);
  const attachPaidUrl = normalizeAttachmentUrl(filing.attach_paid);
  const missingAttachments = !attachConfirmUrl || !attachPaidUrl;

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  async function handleUpdate() {
    setSaving(true); setErr(null);
    try {
      const [uploadedSales, uploadedPaid] = await Promise.all([
        uploadFileToServer(salesFileConfirm),
        uploadFileToServer(paidFile),
      ]);
      const payload = {
        start_period: trimOrEmpty(filing.start_period),
        end_period: trimOrEmpty(filing.end_period),
        status: trimOrEmpty(filing.status),
        tenant_id: filing.tenant_id,
        company_id: filing.company_id,
        sales_invoices_ids: normalizeCsvIds(salesIds),
        purchases_invoices_ids: normalizeCsvIds(purchasesIds),
        attach_confirm: normalizeAttachmentUrl(uploadedSales || attachConfirmUrl || ""),
        attach_paid: normalizeAttachmentUrl(uploadedPaid || attachPaidUrl || ""),
      };
      const result = await putTaxReportUpdate(getFilingId(filing), payload);
      const json = result?.json;
      if (json?.status === 1 || result?.res?.ok) { onUpdated?.(); onClose(); }
      else setErr(json?.message || result?.raw?.slice(0, 180) || (isAr ? "حدث خطأ أثناء التحديث" : "Update failed"));
    } catch(e) { setErr(e.message); }
    finally { setSaving(false); }
  }

  async function handleDelete() {
    setDeleting(true); setErr(null);
    try {
      const res  = await fetch(`${BASE_URL}/sales/zatca-tax-report/delete/${filing.id}`, { method: "DELETE" });
      const json = await res.json();
      if (json.status === 1 || res.ok) { onDeleted?.(); onClose(); }
      else setErr(json.message || (isAr ? "حدث خطأ أثناء الحذف" : "Delete failed"));
    } catch(e) { setErr(e.message); }
    finally { setDeleting(false); }
  }

  const statusColor = filing.status === "approved" ? "#15803d" : filing.status === "pending" ? "#d97706" : "#64748b";
  const statusLabel = isAr
    ? (filing.status === "approved" ? "معتمد" : filing.status === "pending" ? "قيد المراجعة" : filing.status)
    : (filing.status === "approved" ? "Approved" : filing.status === "pending" ? "Pending" : filing.status);

  const modal = (
    <div onClick={onClose} style={{position:"fixed",inset:0,zIndex:99999,background:"rgba(15,23,42,.45)",display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#f0f4f8",borderRadius:12,width:"min(96vw,780px)",maxHeight:"min(92vh, 720px)",display:"flex",flexDirection:"column",boxShadow:"0 16px 56px rgba(10,18,35,.45)",direction:isAr?"rtl":"ltr",fontFamily:"'Cairo',sans-serif",animation:"fadeUp .18s ease forwards",overflow:"hidden"}}>
        {/* Header */}
        <div style={{padding:"12px 16px",background:"#251658",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
          <div style={{background:"rgba(255,255,255,.15)",borderRadius:7,padding:"5px 6px",display:"flex",alignItems:"center"}}><IconStamp/></div>
          <span style={{flex:1,fontWeight:800,fontSize:14,color:"#fff"}}>{isAr?"تفاصيل الإقرار الضريبي":"Tax Filing Details"}</span>
          <span style={{fontSize:11,fontWeight:700,color:statusColor,background:"#fff",padding:"3px 10px",borderRadius:20,border:`1px solid ${statusColor}40`}}>{statusLabel}</span>
          <button onClick={onClose} style={{background:"rgba(255,255,255,.15)",border:"none",cursor:"pointer",color:"#fff",fontSize:22,lineHeight:1,padding:"0 8px",borderRadius:6}}>×</button>
        </div>

        {/* Body */}
        <div style={{overflowY:"auto",flex:1,padding:"14px 16px",display:"flex",flexDirection:"column",gap:10,background:"#f0f4f8"}}>
          {err && <div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"10px 14px",color:"#b91c1c",fontSize:13,display:"flex",alignItems:"center",gap:8}}><IconAlert/> {err}</div>}

          {/* تنبيه المرفقات الناقصة */}
          {missingAttachments && !editMode && (
            <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"10px 14px",display:"flex",alignItems:"center",gap:8,fontSize:13,color:"#92400e"}}>
              <IconAlert/>
              <span style={{flex:1}}>
                {isAr
                  ? `${!attachConfirmUrl && !attachPaidUrl ? "مرفق اشعار المبيعات ومرفق السداد" : !attachConfirmUrl ? "مرفق اشعار المبيعات" : "مرفق السداد"} غير مرفق — يرجى إضافته من «تعديل المرفقات»`
                  : `${!attachConfirmUrl && !attachPaidUrl ? "Sales notice & payment attachments are" : !attachConfirmUrl ? "Sales notice attachment is" : "Payment attachment is"} missing — add via «Edit Attachments»`}
              </span>
              <button onClick={()=>setEditMode(true)} style={{background:"#f59e0b",border:"none",borderRadius:6,padding:"5px 12px",color:"#fff",fontSize:12,cursor:"pointer",fontFamily:"'Cairo',sans-serif",fontWeight:700,flexShrink:0}}>
                {isAr?"إضافة الآن":"Add Now"}
              </button>
            </div>
          )}

          {/* Meta grid */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            {[
              [isAr?"من":"From", displayDate(filing.start_period)],
              [isAr?"إلى":"To",   displayDate(filing.end_period)],
              [isAr?"أنشئ بواسطة":"Created By", filing.created_by ?? "—"],
              [isAr?"تاريخ الإنشاء":"Created At", filing.created_at ? displayDate(filing.created_at.split(" ")[0]) : "—"],
            ].map(([k,v]) => (
              <div key={k} style={{background:"#fff",border:"1px solid #dde3ea",borderRadius:7,padding:"9px 12px",boxShadow:"0 1px 3px rgba(0,0,0,.04)"}}>
                <div style={{fontSize:11,color:"#7a8ca0",fontWeight:600,marginBottom:3}}>{k}</div>
                <div style={{fontSize:13,fontWeight:700,color:"#1e293b",direction:"ltr",textAlign:isAr?"right":"left"}}>{v}</div>
              </div>
            ))}
          </div>

          {/* Invoice IDs — readonly */}
          {!editMode && (
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              <div style={{background:"#fff",border:"1px solid #dde3ea",borderRadius:7,padding:"8px 12px",boxShadow:"0 1px 3px rgba(0,0,0,.04)"}}>
                <div style={{fontSize:11,color:"#7a8ca0",fontWeight:600,marginBottom:4}}>{isAr?"فواتير المبيعات":"Sales Invoice IDs"}</div>
                <textarea value={salesIds} readOnly rows={2} style={{width:"100%",border:"1px solid #e2e8f0",borderRadius:6,padding:"6px 8px",fontSize:12,fontFamily:"'Cairo',sans-serif",resize:"none",color:"#64748b",direction:"ltr",background:"#f8fafc",outline:"none",cursor:"default"}} />
              </div>
              <div style={{background:"#fff",border:"1px solid #dde3ea",borderRadius:7,padding:"8px 12px",boxShadow:"0 1px 3px rgba(0,0,0,.04)"}}>
                <div style={{fontSize:11,color:"#7a8ca0",fontWeight:600,marginBottom:4}}>{isAr?"فواتير المشتريات":"Purchases Invoice IDs"}</div>
                <textarea value={purchasesIds} readOnly rows={2} style={{width:"100%",border:"1px solid #e2e8f0",borderRadius:6,padding:"6px 8px",fontSize:12,fontFamily:"'Cairo',sans-serif",resize:"none",color:"#64748b",direction:"ltr",background:"#f8fafc",outline:"none",cursor:"default"}} />
              </div>
            </div>
          )}

          {/* Attachments */}
          {!editMode ? (
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              {/* Sales Notice Confirm */}
              <div style={{background:"#fff",border:"1px solid #dde3ea",borderRadius:8,padding:"12px 14px",boxShadow:"0 1px 3px rgba(0,0,0,.04)"}}>
                <div style={{fontSize:11,color:"#7a8ca0",fontWeight:600,marginBottom:6,display:"flex",alignItems:"center",gap:5}}>
                  <IconPaperclip/>
                  {isAr?"مرفق اشعار المبيعات":"Sales Notice Attachment"}
                  {!attachConfirmUrl && <span style={{background:"#fef2f2",color:"#b91c1c",borderRadius:4,padding:"1px 6px",fontSize:10,fontWeight:700,marginInlineStart:4}}>!</span>}
                </div>
                {attachConfirmUrl
                  ? <button type="button" onClick={()=>{setPreviewFile(attachConfirmUrl);setPreviewTitle(isAr?"مرفق اشعار المبيعات":"Sales Notice Attachment");}} style={{fontSize:12,color:ERP_PRIMARY,background:"none",border:"none",cursor:"pointer",padding:0}}>{isAr?"عرض الملف":"View file"}</button>
                  : <span style={{fontSize:12,color:"#94a3b8"}}>—</span>
                }
                {attachConfirmUrl && (isImageFile(attachConfirmUrl) || isPdfFile(attachConfirmUrl)) && (
                  <div style={{marginTop:8,border:"1px solid #e2e8f0",borderRadius:6,overflow:"hidden",background:"#fff"}}>
                    {isImageFile(attachConfirmUrl) && <img src={attachConfirmUrl} alt="sales-notice-preview" style={{width:"100%",height:72,objectFit:"cover"}} />}
                    {isPdfFile(attachConfirmUrl) && <iframe title="sales-notice-preview" src={attachConfirmUrl} style={{width:"100%",height:80,border:"none"}} />}
                  </div>
                )}
              </div>
              {/* Paid */}
              <div style={{background:"#fff",border:"1px solid #dde3ea",borderRadius:8,padding:"12px 14px",boxShadow:"0 1px 3px rgba(0,0,0,.04)"}}>
                <div style={{fontSize:11,color:"#7a8ca0",fontWeight:600,marginBottom:6,display:"flex",alignItems:"center",gap:5}}>
                  <IconPaperclip/>
                  {isAr?"مرفق اشعار السداد":"Payment Notice Attachment"}
                  {!attachPaidUrl && <span style={{background:"#fef2f2",color:"#b91c1c",borderRadius:4,padding:"1px 6px",fontSize:10,fontWeight:700,marginInlineStart:4}}>!</span>}
                </div>
                {attachPaidUrl
                  ? <button type="button" onClick={()=>{setPreviewFile(attachPaidUrl);setPreviewTitle(isAr?"مرفق اشعار السداد":"Payment Notice Attachment");}} style={{fontSize:12,color:ERP_PRIMARY,background:"none",border:"none",cursor:"pointer",padding:0}}>{isAr?"عرض الملف":"View file"}</button>
                  : <span style={{fontSize:12,color:"#94a3b8"}}>—</span>
                }
                {attachPaidUrl && (isImageFile(attachPaidUrl) || isPdfFile(attachPaidUrl)) && (
                  <div style={{marginTop:8,border:"1px solid #e2e8f0",borderRadius:6,overflow:"hidden",background:"#fff"}}>
                    {isImageFile(attachPaidUrl) && <img src={attachPaidUrl} alt="paid-preview" style={{width:"100%",height:72,objectFit:"cover"}} />}
                    {isPdfFile(attachPaidUrl) && <iframe title="paid-preview" src={attachPaidUrl} style={{width:"100%",height:80,border:"none"}} />}
                  </div>
                )}
              </div>
            </div>
          ) : (
            /* ── edit mode: attachments only (UI) ── */
            <div style={{background:"#fff",border:"1px solid #e2e8f0",borderRadius:10,padding:"12px 14px",display:"flex",flexDirection:"column",gap:10}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  [isAr?"مرفق اشعار المبيعات":"Sales Notice Attachment",   salesFileConfirm, setSalesFileConfirm, "salesConfirmEdit"],
                  [isAr?"مرفق اشعار السداد":"Payment Notice Attachment",   paidFile,         setPaidFile,         "paidFileEdit"],
                ].map(([label, file, setFile, key]) => (
                  <div key={key} style={{background:"#f8fafc",border:`1px solid ${file?"#86efac":"#e2e8f0"}`,borderRadius:8,padding:"10px 12px"}}>
                    <div style={{fontSize:11,color:"#475569",fontWeight:700,marginBottom:6,display:"flex",alignItems:"center",gap:5}}><IconPaperclip/>{label}</div>
                    <label style={{display:"flex",alignItems:"center",gap:6,border:`1.5px dashed ${file?"#86efac":"#cbd5e1"}`,borderRadius:6,padding:"7px 10px",cursor:"pointer",background:file?"#f0fdf4":"#fff",overflow:"hidden"}}>
                      <span style={{fontSize:12,color:file?"#15803d":"#94a3b8",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",minWidth:0}}>
                        {file ? file.name : (isAr?"اختر ملف":"Choose file")}
                      </span>
                      {file
                        ? <button type="button" onClick={e=>{e.preventDefault();e.stopPropagation();setFile(null);}} style={{color:"#dc2626",background:"none",border:"none",cursor:"pointer",fontSize:18,lineHeight:1,padding:0,flexShrink:0}}>×</button>
                        : <span style={{flexShrink:0,color:"#94a3b8"}}><IconPaperclip/></span>
                      }
                      <input type="file" accept="image/*,.pdf" style={{display:"none"}} onChange={e=>setFile(e.target.files[0]||null)} />
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer actions */}
        <div style={{padding:"10px 16px",borderTop:"1px solid #dde3ea",background:"#e8edf2",display:"flex",alignItems:"center",gap:8,flexShrink:0,flexWrap:"wrap",direction:isAr?"rtl":"ltr"}}>
          {!editMode && !confirmDelete && (
            <>
              <button
                onClick={()=>setShowViewDeclaration(true)}
                style={{background:"#f0fdf4",border:"1px solid #86efac",borderRadius:7,padding:"7px 16px",color:"#15803d",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontWeight:700}}
              >
                <IconChart/> {isAr?"عرض الإقرار":"View Declaration"}
              </button>
              <button
                onClick={()=>setShowEditDeclaration(true)}
                style={{background:"#251658",border:"1px solid #1a0f42",borderRadius:7,padding:"7px 16px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontWeight:700}}
              >
                <IconStamp/> {isAr?"تعديل الإقرار الضريبي":"Edit Tax Filing"}
              </button>
              <button onClick={()=>{setEditMode(true);setEditStep(2);}} style={{background:"#f8fafc",border:"1px solid #cbd5e1",borderRadius:7,padding:"7px 16px",color:ERP_PRIMARY,fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontWeight:700}}>
                <IconEdit/> {isAr?"تعديل المرفقات":"Edit Attachments"}
              </button>
              <button onClick={()=>setConfirmDelete(true)} style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:7,padding:"7px 16px",color:"#dc2626",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontWeight:700,marginInlineStart:"auto"}}>
                <IconTrash/> {isAr?"حذف":"Delete"}
              </button>
            </>
          )}
          {confirmDelete && !editMode && (
            <>
              <span style={{flex:1,fontSize:13,color:"#dc2626",fontWeight:700}}>{isAr?"هل أنت متأكد من الحذف؟":"Confirm delete?"}</span>
              <button onClick={()=>setConfirmDelete(false)} style={{background:"#fff",border:"1px solid #cbd5e1",borderRadius:7,padding:"7px 14px",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer"}}>{isAr?"إلغاء":"Cancel"}</button>
              <button onClick={handleDelete} disabled={deleting} style={{background:"#dc2626",border:"none",borderRadius:7,padding:"7px 16px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",fontWeight:700,opacity:deleting?.6:1}}>
                {deleting ? (isAr?"جاري الحذف...":"Deleting...") : (isAr?"تأكيد الحذف":"Confirm Delete")}
              </button>
            </>
          )}
          {editMode && (
            <>
              <button onClick={()=>{setEditMode(false);setSalesFileConfirm(null);setPaidFile(null);setEditStep(2);}} style={{background:"#fff",border:"1px solid #cbd5e1",borderRadius:7,padding:"7px 14px",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer"}}>{isAr?"إلغاء":"Cancel"}</button>
              <button onClick={handleUpdate} disabled={saving} style={{background:ERP_PRIMARY,border:"none",borderRadius:7,padding:"7px 18px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",fontWeight:700,display:"flex",alignItems:"center",gap:6,marginInlineStart:"auto",opacity:saving?.6:1}}>
                <IconCheck/> {saving ? (isAr?"جاري الحفظ...":"Saving...") : (isAr?"حفظ التعديلات":"Save Changes")}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
  return (
    <>
      {ReactDOM.createPortal(modal, document.body)}
      {showEditDeclaration && (
        <ZatcaFilingModal
          isAr={isAr}
          dateRange={dateRange || { from: filing.start_period, to: filing.end_period }}
          tenantId={tenantId || filing.tenant_id}
          companyId={companyId || filing.company_id}
          salesInvoices={salesInvoices || []}
          purchasesInvoices={purchasesInvoices || []}
          onClose={()=>setShowEditDeclaration(false)}
          onSuccess={()=>{
            setShowEditDeclaration(false);
            onUpdated?.();
          }}
          periodLabel={periodLabel}
          salesData={salesData}
          purchasesData={purchasesData}
          taxRateLabel={taxRateLabel}
          editMode={true}
          initialFiling={filing}
          initialStep={2}
        />
      )}
      {showViewDeclaration && (
        <ZatcaFilingModal
          isAr={isAr}
          dateRange={dateRange || { from: filing.start_period, to: filing.end_period }}
          tenantId={tenantId || filing.tenant_id}
          companyId={companyId || filing.company_id}
          salesInvoices={salesInvoices || []}
          purchasesInvoices={purchasesInvoices || []}
          onClose={()=>setShowViewDeclaration(false)}
          onSuccess={()=>setShowViewDeclaration(false)}
          periodLabel={periodLabel}
          salesData={salesData}
          purchasesData={purchasesData}
          taxRateLabel={taxRateLabel}
          viewMode={true}
          initialFiling={filing}
          initialStep={2}
        />
      )}
      {previewFile && (
        <FilePreviewPopup
          fileUrl={previewFile}
          title={previewTitle}
          isAr={isAr}
          onClose={()=>setPreviewFile(null)}
        />
      )}
    </>
  );
}

// ─── ZatcaFilingBar ───────────────────────────────────────────────────────────
function ZatcaFilingBar({
  isAr,
  dateRange,
  tenantId,
  companyId,
  refreshKey,
  onRefresh,
  salesInvoices,
  purchasesInvoices,
  periodLabel,
  salesData,
  purchasesData,
  taxRateLabel,
}) {
  const [filings, setFilings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!tenantId || !companyId || !dateRange?.from || !dateRange?.to) return;
    setLoading(true);
    const branchId = getBranchId() ?? "0";
    fetch(`${BASE_URL}/sales/zatca-tax-report/${tenantId}/${companyId}/${branchId}`)
      .then(r => r.json())
      .then(json => {
        const list = Array.isArray(json.data) ? json.data : (Array.isArray(json) ? json : []);
        setFilings(list.filter(f => {
          if (!f.start_period || !f.end_period) return true;
          return f.start_period <= dateRange.to && f.end_period >= dateRange.from;
        }));
      })
      .catch(() => setFilings([]))
      .finally(() => setLoading(false));
  }, [tenantId, companyId, dateRange, refreshKey]);

  if (loading) return (
    <div style={{background:"#eff6ff",borderBottom:"1px solid #bfdbfe",padding:"10px 20px",display:"flex",alignItems:"center",gap:8,fontSize:13,color:"#2563eb"}}>
      <span style={{display:"inline-block",width:14,height:14,border:"2px solid #bfdbfe",borderTop:"2px solid #2563eb",borderRadius:"50%",animation:"spin .8s linear infinite"}} />
      {isAr?"جاري تحميل الإقرارات...":"Loading filings..."}
    </div>
  );

  if (!filings.length) return null;

  return (
    <>
      <div style={{background:"linear-gradient(90deg,#f0fdf4,#dcfce7)",borderBottom:"1px solid #86efac",padding:"10px 20px",display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",direction:isAr?"rtl":"ltr"}}>
        <div style={{display:"flex",alignItems:"center",gap:7,color:"#15803d",fontWeight:700,fontSize:13,flexShrink:0}}>
          <IconStamp/> {isAr?"إقرارات ضريبية معتمدة لهذه الفترة":"Tax filings for this period"} ({filings.length})
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",flex:1}}>
          {filings.map(f => (
            <button key={f.id} onClick={()=>setSelected(f)}
              style={{background:"#fff",border:"1px solid #86efac",borderRadius:20,padding:"4px 14px",fontSize:12,fontWeight:600,color:"#15803d",cursor:"pointer",fontFamily:"'Cairo',sans-serif",display:"flex",alignItems:"center",gap:6,boxShadow:"0 1px 4px rgba(0,0,0,.06)",transition:"all .15s"}}
              onMouseEnter={e=>{e.currentTarget.style.background="#f0fdf4";e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,.1)";}}
              onMouseLeave={e=>{e.currentTarget.style.background="#fff";e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,.06)";}}
            >
              <span style={{width:7,height:7,borderRadius:"50%",background:f.status==="approved"?"#15803d":f.status==="pending"?"#d97706":"#94a3b8",display:"inline-block",flexShrink:0}} />
              {displayDate(f.start_period)} → {displayDate(f.end_period)}
            </button>
          ))}
        </div>
      </div>
      {selected && (
        <ZatcaFilingDetailPopup
          filing={selected}
          isAr={isAr}
          onClose={()=>setSelected(null)}
          onDeleted={()=>{ setSelected(null); onRefresh?.(); }}
          onUpdated={()=>{ setSelected(null); onRefresh?.(); }}
          dateRange={dateRange}
          tenantId={tenantId}
          companyId={companyId}
          salesInvoices={salesInvoices}
          purchasesInvoices={purchasesInvoices}
          periodLabel={periodLabel}
          salesData={salesData}
          purchasesData={purchasesData}
          taxRateLabel={taxRateLabel}
        />
      )}
    </>
  );
}

// ─── ZatcaFilingModal ─────────────────────────────────────────────────────────
// ─── InvoiceCheckboxList ──────────────────────────────────────────────────────
function InvoiceCheckboxList({ invoices, selectedIds, onToggle, onSelectAll, onDeselectAll, isAr, type }) {
  const allSelected = invoices.length > 0 && invoices.every(inv => selectedIds.has(String(inv.id)));
  const someSelected = invoices.some(inv => selectedIds.has(String(inv.id)));
  const fmt2 = (v) => v != null ? Number(v).toLocaleString("en-SA",{minimumFractionDigits:2,maximumFractionDigits:2}) : "—";
  const getAmt = (inv) => inv.total_amount ?? inv.net_amount ?? inv.inv_details_sum_product_net_total ?? null;
  const getVat2 = (inv) => inv.vat_amount ?? inv.inv_details_sum_product_vat ?? null;

  return (
    <div style={{border:"1px solid #e2e8f0",borderRadius:8,overflow:"hidden"}}>
      {/* select all bar */}
      <div style={{background:"#f8fafc",borderBottom:"1px solid #e2e8f0",padding:"7px 12px",display:"flex",alignItems:"center",gap:10,direction:isAr?"rtl":"ltr"}}>
        <input type="checkbox" checked={allSelected} ref={el=>{ if(el) el.indeterminate = !allSelected && someSelected; }}
          onChange={e => e.target.checked ? onSelectAll() : onDeselectAll()}
          style={{width:15,height:15,cursor:"pointer",flexShrink:0}} />
        <span style={{fontSize:12,fontWeight:700,color:"#475569",flex:1}}>
          {isAr ? `${selectedIds.size} / ${invoices.length} فاتورة محددة` : `${selectedIds.size} / ${invoices.length} selected`}
        </span>
        <button type="button" onClick={onSelectAll} style={{fontSize:11,color:"#2563eb",background:"none",border:"none",cursor:"pointer",padding:"2px 6px",borderRadius:4,fontFamily:"'Cairo',sans-serif"}}>
          {isAr?"تحديد الكل":"Select All"}
        </button>
        <button type="button" onClick={onDeselectAll} style={{fontSize:11,color:"#dc2626",background:"none",border:"none",cursor:"pointer",padding:"2px 6px",borderRadius:4,fontFamily:"'Cairo',sans-serif"}}>
          {isAr?"إلغاء الكل":"Deselect All"}
        </button>
      </div>
      {/* list */}
      <div style={{height:145,maxHeight:145,overflowY:"auto"}}>
        {invoices.length === 0 && (
          <div style={{padding:"14px",textAlign:"center",color:"#94a3b8",fontSize:12}}>{isAr?"لا توجد فواتير":"No invoices"}</div>
        )}
        {invoices.map((inv, i) => {
          const checked = selectedIds.has(String(inv.id));
          const parts = (inv.inv_date ? inv.inv_date.split(" ")[0] : "").split("-");
          const dispDate = parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : "—";
          const amt = getAmt(inv);
          const vat = getVat2(inv);
          return (
            <div key={inv.id} onClick={()=>onToggle(inv.id)}
              style={{display:"flex",alignItems:"center",gap:8,padding:"7px 12px",cursor:"pointer",background:checked?(type==="purchases"?"#f0fdf4":"#eff6ff"):i%2===0?"#fff":"#fafafa",borderBottom:"1px solid #f1f5f9",direction:isAr?"rtl":"ltr",transition:"background .1s"}}>
              <input type="checkbox" checked={checked} onChange={()=>onToggle(inv.id)}
                onClick={e=>e.stopPropagation()}
                style={{width:14,height:14,cursor:"pointer",flexShrink:0}} />
              <span style={{fontWeight:700,fontSize:12,color:type==="purchases"?"#15803d":"#1d4ed8",minWidth:70}}>{inv.inv_no ?? "—"}</span>
              <span style={{fontSize:11,color:"#64748b",flex:1}}>{dispDate}</span>
              {amt != null && (
                <span style={{fontSize:11,fontFamily:"monospace",color:"#334155",direction:"ltr",whiteSpace:"nowrap"}}>
                  {fmt2(amt)}
                </span>
              )}
              {vat != null && (
                <span style={{fontSize:11,fontFamily:"monospace",color:type==="purchases"?"#15803d":"#2563eb",direction:"ltr",whiteSpace:"nowrap",background:type==="purchases"?"#f0fdf4":"#eff6ff",borderRadius:4,padding:"1px 5px"}}>
                  +{fmt2(vat)}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ZatcaFilingModal({
  isAr,
  dateRange,
  tenantId,
  companyId,
  salesInvoices,
  purchasesInvoices,
  onClose,
  onSuccess,
  periodLabel,
  salesSummary,
  purchasesSummary,
  salesData,
  purchasesData: purchasesDataProp,
  taxRateLabel,
  editMode = false,
  initialFiling = null,
  initialStep = 1,
  viewMode = false,
}) {
  const [step, setStep] = useState(initialStep); // 1, 2, 3
  const [salesFileConfirm, setSalesFileConfirm] = useState(null);
  const [paidFile,         setPaidFile]         = useState(null);
  const [selectedSalesIds, setSelectedSalesIds] = useState(() => {
    if (editMode) return new Set(normalizeCsvIds(initialFiling?.sales_invoices_ids ?? "").split(",").filter(Boolean));
    return new Set((salesInvoices||[]).map(i=>String(i.id)));
  });
  const [selectedPurchasesIds, setSelectedPurchasesIds] = useState(() => {
    if (editMode) return new Set(normalizeCsvIds(initialFiling?.purchases_invoices_ids ?? "").split(",").filter(Boolean));
    return new Set((purchasesInvoices||[]).map(i=>String(i.id)));
  });
  const [submitting,  setSubmitting]  = useState(false);
  const [filedRecord, setFiledRecord] = useState(() => editMode ? initialFiling : null); // record from submit/update
  const [err,         setErr]         = useState(null);

  // ── حقول نموذج الإقرار (الخطوة 2) ──────────────────────────────────────────
  // نحسب القيم المبدئية من داتا المبيعات والمشتريات
  const sd = salesData ?? {};
  const pd = purchasesDataProp ?? {};
  function toArr(v) { if (Array.isArray(v)) return v; if (v && typeof v==="object") return Object.values(v); return []; }
  const sInvTotal  = toArr(sd.invoices_total);
  const sInvZero   = toArr(sd.invoices_tax_zero);
  const sInvExempt = toArr(sd.invoices_tax_exempt);
  const sInvVat    = Array.isArray(sd.invoices_vat) ? sd.invoices_vat : [];
  const pInvTotal  = toArr(pd.invoices_total);
  const pInvZero   = toArr(pd.invoices_tax_zero);
  const pInvExempt = toArr(pd.invoices_tax_exempt);
  const pInvVat    = Array.isArray(pd.invoices_vat) ? pd.invoices_vat : [];

  const sInvStd = sInvTotal.length > 0 ? sInvTotal : sInvVat.filter(i=>!new Set([...sInvExempt,...sInvZero].map(x=>x.id)).has(i.id));
  const pInvStd = pInvTotal.length > 0 ? pInvTotal : pInvVat.filter(i=>!new Set([...pInvExempt,...pInvZero].map(x=>x.id)).has(i.id));

  const calcAmt  = (arr) => arr.reduce((s,i)=>s+Number(i.total_amount||0),0);
  const calcVat  = (arr) => arr.reduce((s,i)=>s+Number(i.vat_amount||0),0);
  const s_std_amt = calcAmt(sInvStd);
  const s_zero_amt= calcAmt(sInvZero);
  const s_exempt_amt= calcAmt(sInvExempt);
  const s_total   = s_std_amt + s_zero_amt + s_exempt_amt;
  const s_vat_amt = Number(sd.grand_vat||0) || calcVat(sInvVat);
  const p_std_amt = calcAmt(pInvStd);
  const p_zero_amt= calcAmt(pInvZero);
  const p_exempt_amt= calcAmt(pInvExempt);
  const p_total   = p_std_amt + p_zero_amt + p_exempt_amt;
  const p_vat_amt = Number(pd.grand_vat||0) || calcVat(pInvVat);
  const net_vat   = s_vat_amt - p_vat_amt;

  const fmtF = (v) => v ? Number(v).toFixed(2) : "";

  // حقول الإقرار — initial values من الداتا
  const rLabel = taxRateLabel || "";
  const filingVal = (k, fallback = "") => {
    const v = initialFiling?.[k];
    if (v === null || v === undefined || v === "") return fallback;
    return String(v);
  };
  const initFields = {
    q_1: filingVal("q_1", "0"),
    q_2: filingVal("q_2", "0"),
    sales_amount_1: filingVal("sales_amount_1", fmtF(s_std_amt)),
    sales_amount_2: filingVal("sales_amount_2", ""),
    sales_amount_3: filingVal("sales_amount_3", fmtF(s_zero_amt)),
    sales_amount_4: filingVal("sales_amount_4", ""),
    sales_amount_5: filingVal("sales_amount_5", fmtF(s_exempt_amt)),
    sales_amount_6: filingVal("sales_amount_6", fmtF(s_total)),
    purchase_amount_7: filingVal("purchase_amount_7", fmtF(p_std_amt)),
    purchase_amount_8: filingVal("purchase_amount_8", ""),
    purchase_amount_9: filingVal("purchase_amount_9", ""),
    purchase_amount_10: filingVal("purchase_amount_10", fmtF(p_zero_amt)),
    purchase_amount_11: filingVal("purchase_amount_11", fmtF(p_exempt_amt)),
    purchase_amount_12: filingVal("purchase_amount_12", fmtF(p_total)),
    sales_amount_update_1: filingVal("sales_amount_update_1", ""),
    sales_amount_update_2: filingVal("sales_amount_update_2", ""),
    sales_amount_update_3: filingVal("sales_amount_update_3", ""),
    sales_amount_update_4: filingVal("sales_amount_update_4", ""),
    sales_amount_update_5: filingVal("sales_amount_update_5", ""),
    sales_amount_update_6: filingVal("sales_amount_update_6", ""),
    purchase_amount_update_7: filingVal("purchase_amount_update_7", ""),
    purchase_amount_update_8: filingVal("purchase_amount_update_8", ""),
    purchase_amount_update_9: filingVal("purchase_amount_update_9", ""),
    purchase_amount_update_10: filingVal("purchase_amount_update_10", ""),
    purchase_amount_update_11: filingVal("purchase_amount_update_11", ""),
    purchase_amount_update_12: filingVal("purchase_amount_update_12", ""),
    sales_amount_vat_1: filingVal("sales_amount_vat_1", fmtF(s_vat_amt)),
    sales_amount_vat_6: filingVal("sales_amount_vat_6", fmtF(s_vat_amt)),
    purchase_amount_vat_7: filingVal("purchase_amount_vat_7", fmtF(p_vat_amt)),
    purchase_amount_vat_8: filingVal("purchase_amount_vat_8", ""),
    purchase_amount_vat_9: filingVal("purchase_amount_vat_9", ""),
    purchase_amount_vat_12: filingVal("purchase_amount_vat_12", fmtF(p_vat_amt)),
    total_amount_13: filingVal("total_amount_13", fmtF(net_vat)),
    total_amount_14: filingVal("total_amount_14", ""),
    total_amount_15: filingVal("total_amount_15", ""),
    total_amount_16: filingVal("total_amount_16", fmtF(net_vat)),
  };
  const [fields, setFields] = useState(initFields);
  const setField = (k, v) => setFields(prev => ({ ...prev, [k]: v }));
  const getNumericDisplayValue = (k) => {
    const v = fields[k];
    return v === null || v === undefined || String(v).trim() === "" ? "0.00" : v;
  };
  const setNumericField = (k, v) => setField(k, v === "" ? "0.00" : v);

  const userId = (() => { try { return JSON.parse(localStorage.getItem("user"))?._id ?? ""; } catch { return ""; } })();

  // ── إعادة حساب حقول الإقرار عند تغيير الفواتير المحددة ──────────────────
  useEffect(() => {
    // إجمالي الفواتير المحددة
    const selSalesStd = (salesInvoices||[]).filter(i => selectedSalesIds.has(String(i.id)));
    const selPurchStd = (purchasesInvoices||[]).filter(i => selectedPurchasesIds.has(String(i.id)));

    const newSalesAmt  = selSalesStd.reduce((s,i)=>s+getAmt(i),0);
    const newSalesVat  = selSalesStd.reduce((s,i)=>s+getVat(i),0);
    const newPurchAmt  = selPurchStd.reduce((s,i)=>s+getAmt(i),0);
    const newPurchVat  = selPurchStd.reduce((s,i)=>s+getVat(i),0);

    // نأخذ قيم الصفر والمعفى من الحسابات الأصلية (ما تتأثرش بالتغيير)
    const zeroAmt   = s_zero_amt;
    const exemptAmt = s_exempt_amt;
    const newSalesTotal = newSalesAmt + zeroAmt + exemptAmt;

    const pZeroAmt   = p_zero_amt;
    const pExemptAmt = p_exempt_amt;
    const newPurchTotal = newPurchAmt + pZeroAmt + pExemptAmt;

    const newNetVat = newSalesVat - newPurchVat;

    setFields(prev => ({
      ...prev,
      sales_amount_1:   fmtF(newSalesAmt),
      sales_amount_vat_1: fmtF(newSalesVat),
      sales_amount_vat_6: fmtF(newSalesVat),
      sales_amount_6:   fmtF(newSalesTotal),
      purchase_amount_7:  fmtF(newPurchAmt),
      purchase_amount_vat_7: fmtF(newPurchVat),
      purchase_amount_vat_12: fmtF(newPurchVat),
      purchase_amount_12: fmtF(newPurchTotal),
      total_amount_13: fmtF(newNetVat),
      total_amount_16: fmtF(newNetVat),
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSalesIds, selectedPurchasesIds]);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  function toggleSales(id) {
    const key = String(id);
    setSelectedSalesIds(prev => { const s = new Set(prev); s.has(key) ? s.delete(key) : s.add(key); return s; });
  }
  function togglePurchases(id) {
    const key = String(id);
    setSelectedPurchasesIds(prev => { const s = new Set(prev); s.has(key) ? s.delete(key) : s.add(key); return s; });
  }

  const getAmt = (inv) => Number(inv.total_amount ?? inv.net_amount ?? inv.inv_details_sum_product_net_total ?? 0);
  const getVat = (inv) => Number(inv.vat_amount ?? inv.inv_details_sum_product_vat ?? 0);
  const selectedSalesTotal    = (salesInvoices||[]).filter(i=>selectedSalesIds.has(String(i.id))).reduce((s,i)=>s+getAmt(i),0);
  const selectedPurchasesTotal= (purchasesInvoices||[]).filter(i=>selectedPurchasesIds.has(String(i.id))).reduce((s,i)=>s+getAmt(i),0);
  const selectedSalesVat      = (salesInvoices||[]).filter(i=>selectedSalesIds.has(String(i.id))).reduce((s,i)=>s+getVat(i),0);
  const selectedPurchasesVat  = (purchasesInvoices||[]).filter(i=>selectedPurchasesIds.has(String(i.id))).reduce((s,i)=>s+getVat(i),0);
  const fmtN = (v) => Number(v).toLocaleString("en-SA",{minimumFractionDigits:2,maximumFractionDigits:2});

  // ── الخطوة 2: POST الإقرار ────────────────────────────────────────────────
  async function handleStep2Submit() {
    setSubmitting(true); setErr(null);
    try {
      // بناء الـ payload — الحقول اللي فيها comma تتحول لـ string عادي
      const buildVal = (v) => {
        return trimOrNull(v);
      };
      const normalizedSalesIds = normalizeCsvIds(Array.from(selectedSalesIds).join(","));
      const normalizedPurchasesIds = normalizeCsvIds(Array.from(selectedPurchasesIds).join(","));
      const payload = {
        start_period: trimOrEmpty(editMode ? (initialFiling?.start_period || dateRange.from) : dateRange.from),
        end_period: trimOrEmpty(editMode ? (initialFiling?.end_period || dateRange.to) : dateRange.to),
        tenant_id: tenantId,
        company_id: companyId,
        sales_invoices_ids: normalizedSalesIds,
        purchases_invoices_ids: normalizedPurchasesIds,
        attach_confirm: editMode ? normalizeAttachmentUrl(filedRecord?.attach_confirm || initialFiling?.attach_confirm || "") : "",
        attach_paid: editMode ? normalizeAttachmentUrl(filedRecord?.attach_paid || initialFiling?.attach_paid || "") : "",
        q_1: trimOrEmpty(fields.q_1),
        q_2: trimOrEmpty(fields.q_2),
      };
      if (!editMode) payload.created_by = userId;
      if (editMode) payload.status = trimOrEmpty(initialFiling?.status || filedRecord?.status || "pending");
      // إضافة حقول الأرقام
      const numFields = [
        "sales_amount_1","sales_amount_2","sales_amount_3","sales_amount_4","sales_amount_5","sales_amount_6",
        "purchase_amount_7","purchase_amount_8","purchase_amount_9","purchase_amount_10","purchase_amount_11","purchase_amount_12",
        "sales_amount_update_1","sales_amount_update_2","sales_amount_update_3","sales_amount_update_4","sales_amount_update_5","sales_amount_update_6",
        "purchase_amount_update_7","purchase_amount_update_8","purchase_amount_update_9","purchase_amount_update_10","purchase_amount_update_11","purchase_amount_update_12",
        "sales_amount_vat_1","sales_amount_vat_6",
        "purchase_amount_vat_7","purchase_amount_vat_8","purchase_amount_vat_9","purchase_amount_vat_12",
        "total_amount_13","total_amount_14","total_amount_15","total_amount_16",
      ];
      numFields.forEach(k => { payload[k] = buildVal(fields[k]); });

      if (editMode) {
        const result = await putTaxReportUpdate(getFilingId(initialFiling || filedRecord), payload);
        if (result?.json?.status === 1 || result?.res?.ok) {
          setFiledRecord(result?.json?.data || { ...(filedRecord || initialFiling || {}), ...payload, id: getFilingId(filedRecord || initialFiling) });
          setStep(3);
        } else {
          setErr(result?.json?.message || result?.raw?.slice(0, 180) || (isAr ? "حدث خطأ أثناء الحفظ" : "Submission failed"));
        }
      } else {
        const res  = await fetch(`${BASE_URL}/sales/zatca-tax-report`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const parsed = await parseResponseSafe(res);
        const json = parsed.json;
        if (json?.status === 1 || res.ok) {
          setFiledRecord(json?.data || { ...(filedRecord || initialFiling || {}), ...payload, id: getFilingId(filedRecord || initialFiling) });
          setStep(3);
        } else {
          setErr(json?.message || parsed?.raw?.slice(0, 180) || (isAr ? "حدث خطأ أثناء الحفظ" : "Submission failed"));
        }
      }
    } catch(e) { setErr(e.message); }
    finally { setSubmitting(false); }
  }

  // ── الخطوة 3: PUT المرفقات ────────────────────────────────────────────────
  async function handleStep3Submit() {
    if (!getFilingId(filedRecord)) { onSuccess?.(); onClose(); return; }
    setSubmitting(true); setErr(null);
    try {
      const [uploadedSales, uploadedPaid] = await Promise.all([
        uploadFileToServer(salesFileConfirm),
        uploadFileToServer(paidFile),
      ]);
      const payload = {
        start_period: trimOrEmpty(filedRecord.start_period),
        end_period: trimOrEmpty(filedRecord.end_period),
        status: trimOrEmpty(filedRecord.status),
        tenant_id: filedRecord.tenant_id,
        company_id: filedRecord.company_id,
        sales_invoices_ids: normalizeCsvIds(filedRecord.sales_invoices_ids),
        purchases_invoices_ids: normalizeCsvIds(filedRecord.purchases_invoices_ids),
        attach_confirm: normalizeAttachmentUrl(uploadedSales || filedRecord.attach_confirm || ""),
        attach_paid: normalizeAttachmentUrl(uploadedPaid || filedRecord.attach_paid || ""),
      };
      const result = await putTaxReportUpdate(getFilingId(filedRecord), payload);
      const json = result?.json;
      if (json?.status === 1 || result?.res?.ok) { onSuccess?.(); onClose(); }
      else setErr(json?.message || result?.raw?.slice(0, 180) || (isAr ? "حدث خطأ أثناء رفع المرفقات" : "Attachment upload failed"));
    } catch(e) { setErr(e.message); }
    finally { setSubmitting(false); }
  }

  // ── مساعد لحقل رقمي في نموذج الإقرار ────────────────────────────────────
  function FormField({ label, fieldKey, readOnly = false, highlight = false }) {
    const isReadOnly = readOnly || viewMode;
    if (label) {
      // Totals section: label on top, input below
      return (
        <div style={{display:"flex",flexDirection:"column",gap:3}}>
          <label style={{fontSize:11,color: highlight?"#7c3aed":"#475569",fontWeight:600}}>{label}</label>
          <input
            type="number"
            step="0.01"
            value={getNumericDisplayValue(fieldKey)}
            readOnly={isReadOnly}
            onChange={e => !isReadOnly && setNumericField(fieldKey, e.target.value)}
            style={{
              border:`1px solid ${highlight?"#c4b5fd":"#d1d5db"}`,
              borderRadius:6,padding:"6px 8px",fontSize:12,
              background: isReadOnly ? "#f1f5f9" : highlight ? "#faf5ff" : "#fff",
              color:"#0f172a",outline:"none",textAlign:"center",direction:"ltr",
              fontFamily:"monospace",cursor: isReadOnly?"default":"text",width:"100%",boxSizing:"border-box",fontWeight:700,
            }}
          />
        </div>
      );
    }
    // Grid fields (no label): just the input
    return (
      <input
        type="number"
        step="0.01"
        value={getNumericDisplayValue(fieldKey)}
        readOnly={isReadOnly}
        onChange={e => !isReadOnly && setNumericField(fieldKey, e.target.value)}
        style={{
          border:`1px solid ${highlight?"#c4b5fd":"#d1d5db"}`,
          borderRadius:6,padding:"6px 8px",fontSize:12,
          background: isReadOnly ? "#f1f5f9" : highlight ? "#faf5ff" : "#fff",
          color:"#0f172a",outline:"none",textAlign:"center",direction:"ltr",
          fontFamily:"monospace",cursor: isReadOnly?"default":"text",width:"100%",boxSizing:"border-box",fontWeight:700,
        }}
      />
    );
  }

  // ── حقل بـ Yes/No ─────────────────────────────────────────────────────────
  function RadioField({ label, fieldKey }) {
    return (
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
        <span style={{fontSize:11,color:"#475569",fontWeight:600,flex:1,minWidth:120}}>{label}</span>
        <div style={{display:"flex",gap:10,alignItems:"center",flexShrink:0}}>
          {[{v:"1",l:isAr?"نعم":"Yes"},{v:"0",l:isAr?"لا":"No"}].map(opt=>(
            <label key={opt.v} style={{display:"flex",alignItems:"center",gap:4,cursor:viewMode?"default":"pointer",fontSize:12,color:"#334155"}}>
              <input type="radio" name={fieldKey} value={opt.v}
                checked={String(fields[fieldKey])===opt.v}
                onChange={()=>!viewMode && setField(fieldKey, opt.v)}
                disabled={viewMode}
                style={{cursor:viewMode?"default":"pointer"}}
              />
              {opt.l}
            </label>
          ))}
          {(fields[fieldKey]===null||fields[fieldKey]==="") && (
            <span style={{fontSize:11,color:"#94a3b8"}}>—</span>
          )}
        </div>
      </div>
    );
  }

  // ── محتوى الخطوات ─────────────────────────────────────────────────────────
  const stepTitles = isAr
    ? ["اختيار الفواتير","نموذج الإقرار","إرفاق الإشعارات"]
    : ["Select Invoices","Declaration Form","Attach Notices"];

  const modal = (
    <div onClick={onClose} style={{position:"fixed",inset:0,zIndex:99999,background:"rgba(15,23,42,.45)",display:"flex",alignItems:"center",justifyContent:"center",padding:12}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:14,width:"min(98vw,1100px)",maxHeight:"min(90vh,700px)",display:"flex",flexDirection:"column",boxShadow:"0 16px 60px rgba(0,0,0,.22)",direction:isAr?"rtl":"ltr",fontFamily:"'Cairo',sans-serif",animation:"fadeUp .18s ease forwards",overflow:"hidden"}}>

        {/* ── Header ── */}
        <div style={{padding:"14px 20px",background:"#251658",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
          <div style={{background:"rgba(255,255,255,.16)",borderRadius:8,padding:8,display:"flex",alignItems:"center",justifyContent:"center"}}>
            <IconStamp/>
          </div>
          <div style={{flex:1}}>
            <div style={{fontWeight:800,fontSize:15,color:"#fff",display:"flex",alignItems:"center",gap:8}}>
              {isAr ? (viewMode ? "عرض الإقرار الضريبي" : editMode ? "تعديل الإقرار الضريبي" : "اعتماد الإقرار الضريبي") : (viewMode ? "View Tax Declaration" : editMode ? "Edit Tax Filing" : "Submit Tax Filing")}
              {periodLabel && <span style={{fontSize:13,fontWeight:600,background:"rgba(255,255,255,.18)",borderRadius:20,padding:"2px 10px",color:"#fff"}}>{periodLabel}</span>}
            </div>
            <div style={{fontSize:12,color:"rgba(255,255,255,.7)",marginTop:2}}>{displayDate(dateRange.from)} — {displayDate(dateRange.to)}</div>
          </div>
          {viewMode && (
            <button
              onClick={() => {
                const printContent = document.getElementById("zatca-declaration-print-area");
                if (!printContent) return;
                const win = window.open("", "_blank", "width=900,height=700");
                win.document.write(`<html><head><title>${isAr?"طباعة الإقرار الضريبي":"Print Tax Declaration"}</title>
                  <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;800&display=swap" rel="stylesheet">
                  <style>
                    * { box-sizing: border-box; margin: 0; padding: 0; }
                    body { font-family: 'Cairo', sans-serif; direction: ${isAr ? "rtl" : "ltr"}; padding: 20px; background: #fff; color: #0f172a; }
                    input { border: 1px solid #d1d5db !important; background: #f8fafc !important; cursor: default; }
                    @media print { body { padding: 10px; } }
                  </style>
                </head><body>`);
                win.document.write(printContent.innerHTML);
                win.document.write("</body></html>");
                win.document.close();
                win.focus();
                setTimeout(() => { win.print(); }, 600);
              }}
              style={{background:"rgba(255,255,255,.18)",border:"1px solid rgba(255,255,255,.3)",borderRadius:7,padding:"7px 14px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontWeight:700,flexShrink:0}}
            >
              <IconPrint/> {isAr?"طباعة الإقرار":"Print Declaration"}
            </button>
          )}
          <button onClick={onClose} style={{background:"rgba(255,255,255,.15)",border:"none",cursor:"pointer",color:"#fff",fontSize:20,lineHeight:1,padding:"4px 8px",borderRadius:6}}>×</button>
        </div>

        {/* ── Step Indicators ── */}
        {!viewMode && (
        <div style={{display:"flex",alignItems:"center",padding:"10px 20px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",gap:0,flexShrink:0}}>
          {[1,2,3].map((s,i)=>(
            <div key={s} style={{display:"flex",alignItems:"center",flex:1}}>
              <div style={{display:"flex",alignItems:"center",gap:7,flex:1}}>
                <div style={{
                  width:28,height:28,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",
                  fontWeight:800,fontSize:13,flexShrink:0,
                  background: step>s?"#15803d":step===s?"#251658":"#e2e8f0",
                  color: step>=s?"#fff":"#94a3b8",
                  border: step===s?"2px solid #7c3aed":"none",
                  transition:"all .2s",
                }}>
                  {step>s ? <IconCheck/> : s}
                </div>
                <span style={{fontSize:12,fontWeight:step===s?700:400,color:step===s?"#251658":step>s?"#15803d":"#94a3b8",whiteSpace:"nowrap"}}>
                  {stepTitles[i]}
                </span>
              </div>
              {i<2 && <div style={{flex:1,height:2,background:step>s+1?"#15803d":step===s+1?"#c4b5fd":"#e2e8f0",margin:"0 8px",minWidth:16,transition:"background .2s"}} />}
            </div>
          ))}
        </div>
        )}

        {/* ── Body ── */}
        <div id="zatca-declaration-print-area" style={{padding:"12px 16px",display:"flex",flexDirection:"column",gap:10,overflowY:"auto",flex:1}}>
          {err && <div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"10px 14px",color:"#b91c1c",fontSize:13,display:"flex",alignItems:"center",gap:8}}><IconAlert/> {err}</div>}

          {/* ══ STEP 1: الفواتير ══════════════════════════════════════════ */}
          {step === 1 && (<>
            {salesSummary && (
              <div style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:10,padding:"10px 14px",display:"flex",flexDirection:"column",gap:8}}>
                <div style={{fontSize:11,fontWeight:800,color:"#334155"}}>{isAr?"ملخص الإقرار":"Filing Summary"}</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,minWidth:0}}>
                  <div style={{background:"#fff",border:"1px solid #dbeafe",borderRadius:8,padding:"8px 10px",fontSize:11,minWidth:0,overflow:"hidden"}}>
                    <div style={{fontWeight:800,color:"#1d4ed8",marginBottom:5,fontSize:11}}>{isAr?"المبيعات":"Sales"}</div>
                    <div style={{background:"#eff6ff",borderRadius:5,padding:"4px 7px",marginBottom:4}}>
                      <div style={{color:"#1e40af",fontWeight:700,fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{salesSummary.sectionTitle}</div>
                      <div style={{display:"flex",justifyContent:"space-between",gap:4}}>
                        <span style={{color:"#475569",fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:"1 1 0"}}>{salesSummary.row1Label}</span>
                        <span style={{fontFamily:"monospace",fontWeight:700,color:"#0f172a",fontSize:10,flexShrink:0}}>{fmtN(selectedSalesTotal)}</span>
                      </div>
                    </div>
                    <div style={{background:"#fef9c3",borderRadius:5,padding:"4px 7px"}}>
                      <div style={{display:"flex",justifyContent:"space-between",gap:4}}>
                        <span style={{color:"#475569",fontSize:10,flex:"1 1 0"}}>{isAr?"ضريبة المبيعات":"Sales VAT"}</span>
                        <span style={{fontFamily:"monospace",fontWeight:700,color:"#2563eb",fontSize:10,flexShrink:0}}>{fmtN(selectedSalesVat)}</span>
                      </div>
                    </div>
                    <div style={{fontSize:10,color:"#94a3b8",marginTop:4}}>{isAr?"الفواتير المحددة:":"Selected Invoices:"} {selectedSalesIds.size}</div>
                  </div>
                  <div style={{background:"#fff",border:"1px solid #dcfce7",borderRadius:8,padding:"8px 10px",fontSize:11,minWidth:0,overflow:"hidden"}}>
                    <div style={{fontWeight:800,color:"#15803d",marginBottom:5,fontSize:11}}>{isAr?"المشتريات":"Purchases"}</div>
                    <div style={{background:"#f0fdf4",borderRadius:5,padding:"4px 7px",marginBottom:4}}>
                      <div style={{color:"#166534",fontWeight:700,fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{isAr?`${rLabel ? rLabel : "ضريبة القيمة المضافة"} على المشتريات والمدخلات الأخرى (أساسي)`:(`VAT on Purchases and all other Inputs (Base)`)}</div>
                      <div style={{display:"flex",justifyContent:"space-between",gap:4}}>
                        <span style={{color:"#475569",fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:"1 1 0"}}>{isAr?`7. المشتريات الخاضعة للضريبة الأساسية ${rLabel} (أساسي)`:(`7. Standard Rated Purchases ${rLabel} (Base)`)}</span>
                        <span style={{fontFamily:"monospace",fontWeight:700,color:"#0f172a",fontSize:10,flexShrink:0}}>{fmtN(selectedPurchasesTotal)}</span>
                      </div>
                    </div>
                    <div style={{background:"#fef9c3",borderRadius:5,padding:"4px 7px"}}>
                      <div style={{display:"flex",justifyContent:"space-between",gap:4}}>
                        <span style={{color:"#475569",fontSize:10,flex:"1 1 0"}}>{isAr?"ضريبة المشتريات":"Purchases VAT"}</span>
                        <span style={{fontFamily:"monospace",fontWeight:700,color:"#15803d",fontSize:10,flexShrink:0}}>{fmtN(selectedPurchasesVat)}</span>
                      </div>
                    </div>
                    <div style={{fontSize:10,color:"#94a3b8",marginTop:4}}>{isAr?"الفواتير المحددة:":"Selected Invoices:"} {selectedPurchasesIds.size}</div>
                  </div>
                </div>
              </div>
            )}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(320px,1fr))",gap:10}}>
              <div>
                <div style={{fontSize:12,color:"#1d4ed8",fontWeight:700,marginBottom:6,display:"flex",alignItems:"center",gap:5}}>
                  <span style={{width:8,height:8,borderRadius:"50%",background:"#1d4ed8",display:"inline-block"}}/>
                  {isAr?"فواتير المبيعات":"Sales Invoices"}
                </div>
                <InvoiceCheckboxList invoices={salesInvoices||[]} selectedIds={selectedSalesIds} onToggle={toggleSales}
                  onSelectAll={()=>setSelectedSalesIds(new Set((salesInvoices||[]).map(i=>String(i.id))))}
                  onDeselectAll={()=>setSelectedSalesIds(new Set())} isAr={isAr} type="sales" />
              </div>
              <div>
                <div style={{fontSize:12,color:"#15803d",fontWeight:700,marginBottom:6,display:"flex",alignItems:"center",gap:5}}>
                  <span style={{width:8,height:8,borderRadius:"50%",background:"#15803d",display:"inline-block"}}/>
                  {isAr?"فواتير المشتريات":"Purchases Invoices"}
                </div>
                <InvoiceCheckboxList invoices={purchasesInvoices||[]} selectedIds={selectedPurchasesIds} onToggle={togglePurchases}
                  onSelectAll={()=>setSelectedPurchasesIds(new Set((purchasesInvoices||[]).map(i=>String(i.id))))}
                  onDeselectAll={()=>setSelectedPurchasesIds(new Set())} isAr={isAr} type="purchases" />
              </div>
            </div>
          </>)}

          {/* ══ STEP 2: نموذج الإقرار ════════════════════════════════════ */}
          {step === 2 && (
            <div style={{display:"flex",flexDirection:"column",gap:14}}>

              {/* Q1 / Q2 — نفس الصف نصين */}
              <div style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:8,padding:"10px 14px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:0,direction:isAr?"rtl":"ltr"}}>
                {[
                  {label:isAr?"هل لديك مبيعات أو مشتريات خاضعة لنسبة 5%؟":"Do you have 5% rated sales/purchases?", key:"q_1"},
                  {label:isAr?"هل لديك توريدات للجهات الحكومية؟":"Do you have government supplies?", key:"q_2"},
                ].map(({label,key},qi)=>(
                  <div key={key} style={{display:"flex",alignItems:"center",gap:10,padding:"4px 10px",borderInlineEnd: qi===0?(isAr?"none":"1px solid #e2e8f0"):(isAr?"1px solid #e2e8f0":"none")}}>
                    <span style={{fontSize:11,color:"#334155",fontWeight:600,flex:1}}>{label}</span>
                    <div style={{display:"flex",gap:12,flexShrink:0}}>
                      {[{v:"1",l:isAr?"نعم":"Yes"},{v:"0",l:isAr?"لا":"No"}].map(opt=>(
                        <label key={opt.v} style={{display:"flex",alignItems:"center",gap:4,cursor:viewMode?"default":"pointer",fontSize:12,color:String(fields[key])===opt.v?"#251658":"#64748b",fontWeight:String(fields[key])===opt.v?700:400}}>
                          <input type="radio" name={key} value={opt.v} checked={String(fields[key])===opt.v} onChange={()=>!viewMode&&setField(key,opt.v)} disabled={viewMode} style={{cursor:viewMode?"default":"pointer",width:13,height:13}} />
                          {opt.l}
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              {/* ── VAT on Sales ── */}
              <div style={{background:"#fff",border:"1px solid #dbeafe",borderRadius:8,overflow:"hidden"}}>
                <div style={{background:"#1d4ed8",color:"#fff",padding:"8px 14px",fontSize:12,fontWeight:800,display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:8,direction:isAr?"rtl":"ltr"}}>
                  <span>{isAr?"ضريبة القيمة المضافة على المبيعات":"VAT on Sales"}</span>
                  <span style={{fontSize:10,fontWeight:600,opacity:.85,textAlign:"center"}}>{isAr?"المبلغ (ر.س)":"Amount (SAR)"}</span>
                  <span style={{fontSize:10,fontWeight:600,opacity:.85,textAlign:"center"}}>{isAr?"مبلغ التعديل (ر.س)":"Adjustment (SAR)"}</span>
                  <span style={{fontSize:10,fontWeight:600,opacity:.85,textAlign:"center",color:"#c4b5fd"}}>{isAr?"ضريبة القيمة المضافة (ر.س)":"VAT Amount (SAR)"}</span>
                </div>
                <div style={{display:"flex",flexDirection:"column"}}>
                  {[
                    {label:isAr?`1. المبيعات الخاضعة للنسبة الأساسية ${rLabel}`:`1. Standard Rated Sales ${rLabel}`, note:isAr?`1. المبيعات الخاضعة للضريبة الأساسية ${rLabel} (أساسي)`:`1. Standard Rated Sales ${rLabel} (Base)`, amt:"sales_amount_1", upd:"sales_amount_update_1", vat:"sales_amount_vat_1"},
                    {label:isAr?"2. المبيعات التي تتحمل الدولة ضريبتها":"2. Government-borne Tax Sales", note:null, amt:"sales_amount_2", upd:"sales_amount_update_2", vat:null},
                    {label:isAr?"3. المبيعات المحلية الخاضعة للنسبة الصفرية":"3. Zero-Rated Local Sales", note:null, amt:"sales_amount_3", upd:"sales_amount_update_3", vat:null},
                    {label:isAr?"4. الصادرات":"4. Exports", note:null, amt:"sales_amount_4", upd:"sales_amount_update_4", vat:null},
                    {label:isAr?"5. المبيعات المعفاة من الضريبة":"5. Exempt Sales", note:null, amt:"sales_amount_5", upd:"sales_amount_update_5", vat:null},
                  ].map((row,i)=>(
                    <div key={i} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:8,alignItems:"center",padding:"7px 14px",borderBottom:"1px solid #f1f5f9",direction:isAr?"rtl":"ltr",background:i%2===0?"#fff":"#fafbff"}}>
                      <div>
                        <div style={{fontSize:11,color:"#334155",fontWeight:700}}>{row.label}</div>
                        {row.note && <div style={{fontSize:10,color:"#1d4ed8",background:"#eff6ff",borderRadius:3,padding:"1px 5px",marginTop:2,display:"inline-block"}}>{row.note}</div>}
                      </div>
                      <input type="number" step="0.01" readOnly={viewMode} value={getNumericDisplayValue(row.amt)} onChange={e=>!viewMode&&setNumericField(row.amt,e.target.value)}
                        style={{border:"1px solid #d1d5db",borderRadius:5,padding:"5px 7px",fontSize:11,background:viewMode?"#f8fafc":"#fff",color:"#0f172a",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",fontWeight:700,width:"100%",boxSizing:"border-box",cursor:viewMode?"default":"text"}} />
                      <input type="number" step="0.01" readOnly={viewMode} value={getNumericDisplayValue(row.upd)} onChange={e=>!viewMode&&setNumericField(row.upd,e.target.value)}
                        style={{border:"1px solid #d1d5db",borderRadius:5,padding:"5px 7px",fontSize:11,background:viewMode?"#f8fafc":"#fff",color:"#0f172a",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",fontWeight:700,width:"100%",boxSizing:"border-box",cursor:viewMode?"default":"text"}} />
                      {row.vat
                        ? <input type="number" step="0.01" readOnly={viewMode} value={getNumericDisplayValue(row.vat)} onChange={e=>!viewMode&&setNumericField(row.vat,e.target.value)}
                            style={{border:"1px solid #c4b5fd",borderRadius:5,padding:"5px 7px",fontSize:11,background:viewMode?"#f3e8ff":"#faf5ff",color:"#7c3aed",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",fontWeight:700,width:"100%",boxSizing:"border-box",cursor:viewMode?"default":"text"}} />
                        : <div/>}
                    </div>
                  ))}
                  {/* Row 6 - Total */}
                  <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:8,alignItems:"center",padding:"7px 14px",background:"#eff6ff",direction:isAr?"rtl":"ltr",borderTop:"2px solid #bfdbfe"}}>
                    <span style={{fontSize:11,color:"#1d4ed8",fontWeight:800}}>{isAr?"6. إجمالي المبيعات":"6. Total Sales"}</span>
                    <input type="number" readOnly value={getNumericDisplayValue("sales_amount_6")} style={{border:"1px solid #bfdbfe",borderRadius:5,padding:"5px 7px",fontSize:11,background:"#dbeafe",color:"#1d4ed8",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",width:"100%",boxSizing:"border-box",cursor:"default",fontWeight:700}} />
                    <input type="number" step="0.01" readOnly={viewMode} value={getNumericDisplayValue("sales_amount_update_6")} onChange={e=>!viewMode&&setNumericField("sales_amount_update_6",e.target.value)} style={{border:"1px solid #d1d5db",borderRadius:5,padding:"5px 7px",fontSize:11,background:viewMode?"#f8fafc":"#fff",color:"#0f172a",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",fontWeight:700,width:"100%",boxSizing:"border-box",cursor:viewMode?"default":"text"}} />
                    <input type="number" readOnly value={getNumericDisplayValue("sales_amount_vat_6")} style={{border:"1px solid #c4b5fd",borderRadius:5,padding:"5px 7px",fontSize:11,background:"#e9d5ff",color:"#7c3aed",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",width:"100%",boxSizing:"border-box",cursor:"default",fontWeight:700}} />
                  </div>
                </div>
              </div>

              {/* ── VAT on Purchases ── */}
              <div style={{background:"#fff",border:"1px solid #dcfce7",borderRadius:8,overflow:"hidden"}}>
                <div style={{background:"#15803d",color:"#fff",padding:"8px 14px",fontSize:12,fontWeight:800,display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:8,direction:isAr?"rtl":"ltr"}}>
                  <span>{isAr?"ضريبة القيمة المضافة على المشتريات":"VAT on Purchases"}</span>
                  <span style={{fontSize:10,fontWeight:600,opacity:.85,textAlign:"center"}}>{isAr?"المبلغ (ر.س)":"Amount (SAR)"}</span>
                  <span style={{fontSize:10,fontWeight:600,opacity:.85,textAlign:"center"}}>{isAr?"مبلغ التعديل (ر.س)":"Adjustment (SAR)"}</span>
                  <span style={{fontSize:10,fontWeight:600,opacity:.85,textAlign:"center",color:"#bbf7d0"}}>{isAr?"ضريبة القيمة المضافة (ر.س)":"VAT Amount (SAR)"}</span>
                </div>
                <div style={{display:"flex",flexDirection:"column"}}>
                  {[
                    {label:isAr?`7. المشتريات الخاضعة للنسبة الأساسية ${rLabel}`:`7. Standard Rated Purchases ${rLabel}`, note:isAr?`7. المشتريات الخاضعة للضريبة الأساسية ${rLabel} (أساسي)`:`7. Standard Rated Purchases ${rLabel} (Base)`, amt:"purchase_amount_7", upd:"purchase_amount_update_7", vat:"purchase_amount_vat_7"},
                    {label:isAr?"8. الاستيرادات الخاضعة للضريبة (مدفوعة عند الاستيراد)":"8. Taxable Imports (paid at customs)", note:null, amt:"purchase_amount_8", upd:"purchase_amount_update_8", vat:"purchase_amount_vat_8"},
                    {label:isAr?"9. الاستيرادات بآلية الاحتساب العكسي":"9. Reverse Charge Imports", note:null, amt:"purchase_amount_9", upd:"purchase_amount_update_9", vat:"purchase_amount_vat_9"},
                    {label:isAr?"10. المشتريات الخاضعة للنسبة الصفرية":"10. Zero-Rated Purchases", note:null, amt:"purchase_amount_10", upd:"purchase_amount_update_10", vat:null},
                    {label:isAr?"11. مشتريات معفاة من الضريبة":"11. Exempt Purchases", note:null, amt:"purchase_amount_11", upd:"purchase_amount_update_11", vat:null},
                  ].map((row,i)=>(
                    <div key={i} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:8,alignItems:"center",padding:"7px 14px",borderBottom:"1px solid #f1f5f9",direction:isAr?"rtl":"ltr",background:i%2===0?"#fff":"#f0fdf4"}}>
                      <div>
                        <div style={{fontSize:11,color:"#334155",fontWeight:700}}>{row.label}</div>
                        {row.note && <div style={{fontSize:10,color:"#15803d",background:"#dcfce7",borderRadius:3,padding:"1px 5px",marginTop:2,display:"inline-block"}}>{row.note}</div>}
                      </div>
                      <input type="number" step="0.01" readOnly={viewMode} value={getNumericDisplayValue(row.amt)} onChange={e=>!viewMode&&setNumericField(row.amt,e.target.value)}
                        style={{border:"1px solid #d1d5db",borderRadius:5,padding:"5px 7px",fontSize:11,background:viewMode?"#f8fafc":"#fff",color:"#0f172a",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",fontWeight:700,width:"100%",boxSizing:"border-box",cursor:viewMode?"default":"text"}} />
                      <input type="number" step="0.01" readOnly={viewMode} value={getNumericDisplayValue(row.upd)} onChange={e=>!viewMode&&setNumericField(row.upd,e.target.value)}
                        style={{border:"1px solid #d1d5db",borderRadius:5,padding:"5px 7px",fontSize:11,background:viewMode?"#f8fafc":"#fff",color:"#0f172a",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",fontWeight:700,width:"100%",boxSizing:"border-box",cursor:viewMode?"default":"text"}} />
                      {row.vat
                        ? <input type="number" step="0.01" readOnly={viewMode} value={getNumericDisplayValue(row.vat)} onChange={e=>!viewMode&&setNumericField(row.vat,e.target.value)}
                            style={{border:"1px solid #86efac",borderRadius:5,padding:"5px 7px",fontSize:11,background:viewMode?"#f0fdf4":"#f0fdf4",color:"#15803d",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",fontWeight:700,width:"100%",boxSizing:"border-box",cursor:viewMode?"default":"text"}} />
                        : <div/>}
                    </div>
                  ))}
                  {/* Row 12 - Total */}
                  <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:8,alignItems:"center",padding:"7px 14px",background:"#dcfce7",direction:isAr?"rtl":"ltr",borderTop:"2px solid #86efac"}}>
                    <span style={{fontSize:11,color:"#15803d",fontWeight:800}}>{isAr?"12. إجمالي المشتريات":"12. Total Purchases"}</span>
                    <input type="number" readOnly value={getNumericDisplayValue("purchase_amount_12")} style={{border:"1px solid #86efac",borderRadius:5,padding:"5px 7px",fontSize:11,background:"#bbf7d0",color:"#15803d",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",width:"100%",boxSizing:"border-box",cursor:"default",fontWeight:700}} />
                    <input type="number" step="0.01" readOnly={viewMode} value={getNumericDisplayValue("purchase_amount_update_12")} onChange={e=>!viewMode&&setNumericField("purchase_amount_update_12",e.target.value)} style={{border:"1px solid #d1d5db",borderRadius:5,padding:"5px 7px",fontSize:11,background:viewMode?"#f8fafc":"#fff",color:"#0f172a",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",fontWeight:700,width:"100%",boxSizing:"border-box",cursor:viewMode?"default":"text"}} />
                    <input type="number" readOnly value={getNumericDisplayValue("purchase_amount_vat_12")} style={{border:"1px solid #86efac",borderRadius:5,padding:"5px 7px",fontSize:11,background:"#bbf7d0",color:"#15803d",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",width:"100%",boxSizing:"border-box",cursor:"default",fontWeight:700}} />
                  </div>
                </div>
              </div>

              {/* ── Totals 13-16 — الكلام على اليمين والـ input قدامه ── */}
              <div style={{background:"#fff",border:"1px solid #e9d5ff",borderRadius:8,overflow:"hidden"}}>
                <div style={{background:"#7c3aed",color:"#fff",padding:"8px 14px",fontSize:12,fontWeight:800}}>{isAr?"الإجماليات":"Totals"}</div>
                <div style={{display:"flex",flexDirection:"column",direction:isAr?"rtl":"ltr"}}>
                  {[
                    {label:isAr?"13. إجمالي ضريبة القيمة المضافة المستحقة للفترة الحالية":"13. Total VAT Due (Current Period)", key:"total_amount_13", highlight:true, readOnly:false},
                    {label:isAr?"14. تصحيحات من فترات سابقة":"14. Prior Period Corrections", key:"total_amount_14", highlight:false, readOnly:false},
                    {label:isAr?"15. ضريبة مرحّلة من فترات سابقة":"15. VAT Carried Over from Previous Periods", key:"total_amount_15", highlight:false, readOnly:false},
                    {label:isAr?"16. صافي الضريبة المستحق (أو المستعادة)":"16. Net VAT Due (or Reclaimed)", key:"total_amount_16", highlight:true, readOnly:true},
                  ].map((row,i)=>(
                    <div key={i} style={{display:"grid",gridTemplateColumns:"1fr auto",alignItems:"center",gap:12,padding:"8px 14px",borderBottom:i<3?"1px solid #f3e8ff":"none",background:i%2===0?"#fff":"#faf5ff"}}>
                      <span style={{fontSize:11,color:row.highlight?"#7c3aed":"#334155",fontWeight:row.highlight?700:600}}>{row.label}</span>
                      <input type="number" step="0.01" readOnly={row.readOnly || viewMode} value={getNumericDisplayValue(row.key)} onChange={e=>!(row.readOnly||viewMode)&&setNumericField(row.key,e.target.value)}
                        style={{border:`1px solid ${row.highlight?"#c4b5fd":"#d1d5db"}`,borderRadius:6,padding:"6px 10px",fontSize:12,background:(row.readOnly||viewMode)?"#f3e8ff":row.highlight?"#faf5ff":"#fff",color:row.highlight?"#7c3aed":"#0f172a",outline:"none",textAlign:"center",direction:"ltr",fontFamily:"monospace",width:160,cursor:(row.readOnly||viewMode)?"default":"text",fontWeight:700}} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ══ STEP 3: المرفقات ═══════════════════════════════════════════ */}
          {step === 3 && (
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <div style={{background:"#f0fdf4",border:"1px solid #86efac",borderRadius:8,padding:"10px 14px",display:"flex",alignItems:"center",gap:8,fontSize:13,color:"#15803d",fontWeight:700}}>
                <IconCheck/> {isAr ? (editMode ? "تم تحديث الإقرار بنجاح، يمكنك الآن تحديث المرفقات." : "تم حفظ الإقرار بنجاح، يمكنك الآن إرفاق الإشعارات") : (editMode ? "Declaration updated. You can now update attachments." : "Declaration saved. You can now attach notices.")}
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:10}}>
                {[
                  [isAr?"مرفق اشعار المبيعات":"Sales Notice Attachment", salesFileConfirm, setSalesFileConfirm, "salesConfirm"],
                  [isAr?"مرفق اشعار السداد":"Payment Notice Attachment", paidFile, setPaidFile, "paidFile"],
                ].map(([label, file, setFile, key]) => (
                  <div key={key} style={{background:"#f8fafc",border:`1px solid ${file?"#86efac":"#e2e8f0"}`,borderRadius:8,padding:"10px 14px",transition:"border-color .15s"}}>
                    <div style={{fontSize:12,color:"#475569",fontWeight:700,marginBottom:8,display:"flex",alignItems:"center",gap:5}}><IconPaperclip/>{label}</div>
                    <label style={{display:"flex",alignItems:"center",gap:8,border:`1.5px dashed ${file?"#86efac":"#cbd5e1"}`,borderRadius:7,padding:"9px 12px",cursor:"pointer",background:file?"#f0fdf4":"#fff",transition:"all .15s",overflow:"hidden"}}>
                      <span style={{fontSize:12,color:file?"#15803d":"#94a3b8",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",minWidth:0}}>
                        {file ? file.name : (isAr?"صورة أو PDF":"Image or PDF")}
                      </span>
                      {file
                        ? <button type="button" onClick={e=>{e.preventDefault();e.stopPropagation();setFile(null);}} style={{color:"#dc2626",background:"none",border:"none",cursor:"pointer",fontSize:18,lineHeight:1,padding:0,flexShrink:0}}>×</button>
                        : <span style={{flexShrink:0,color:"#94a3b8"}}><IconPaperclip/></span>
                      }
                      <input type="file" accept="image/*,.pdf" style={{display:"none"}} onChange={e=>setFile(e.target.files[0]||null)} />
                    </label>
                  </div>
                ))}
              </div>
              <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#92400e"}}>
                {isAr?"يمكنك تخطي هذه الخطوة والرفع لاحقاً من تفاصيل الإقرار":"You can skip this step and upload later from filing details."}
              </div>
            </div>
          )}
        </div>

        {/* ── Footer ── */}
        <div style={{padding:"12px 20px",borderTop:"1px solid #e2e8f0",display:"flex",gap:10,justifyContent:"flex-end",direction:isAr?"rtl":"ltr",alignItems:"center",flexShrink:0,background:"#f8fafc"}}>
          {viewMode ? (
            <button onClick={onClose} style={{background:ERP_PRIMARY,border:"none",borderRadius:8,padding:"9px 22px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",fontWeight:700}}>{isAr?"إغلاق":"Close"}</button>
          ) : (<>
          {step === 1 && (<>
            <span style={{flex:1,fontSize:12,color:"#64748b"}}>
              {isAr ? `${selectedSalesIds.size} مبيعات · ${selectedPurchasesIds.size} مشتريات` : `${selectedSalesIds.size} sales · ${selectedPurchasesIds.size} purchases`}
            </span>
            <button onClick={onClose} style={{background:"#fff",border:"1px solid #cbd5e1",borderRadius:8,padding:"9px 20px",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",color:"#475569",fontWeight:600}}>{isAr?"إلغاء":"Cancel"}</button>
            <button onClick={()=>setStep(2)} style={{background:ERP_PRIMARY,border:"none",borderRadius:8,padding:"9px 22px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",fontWeight:800,display:"flex",alignItems:"center",gap:7}}>
              {isAr?"التالي ←":"Next →"}
            </button>
          </>)}
          {step === 2 && (<>
            <button onClick={()=>setStep(1)} style={{background:"#fff",border:"1px solid #cbd5e1",borderRadius:8,padding:"9px 20px",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",color:"#475569",fontWeight:600}}>{isAr?"→ السابق":"← Back"}</button>
            <button onClick={handleStep2Submit} disabled={submitting} style={{background:ERP_PRIMARY,border:"none",borderRadius:8,padding:"9px 22px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",fontWeight:800,display:"flex",alignItems:"center",gap:7,opacity:submitting?.6:1}}>
              <IconCheck/> {submitting ? (isAr?"جاري الحفظ...":"Saving...") : (isAr?"حفظ والتالي ←":"Save & Next →")}
            </button>
          </>)}
          {step === 3 && (<>
            <button onClick={()=>{ onSuccess?.(); onClose(); }} style={{background:"#fff",border:"1px solid #cbd5e1",borderRadius:8,padding:"9px 20px",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",color:"#475569",fontWeight:600}}>{isAr?"تخطي":"Skip"}</button>
            <button onClick={handleStep3Submit} disabled={submitting} style={{background:"#15803d",border:"none",borderRadius:8,padding:"9px 22px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",cursor:"pointer",fontWeight:800,display:"flex",alignItems:"center",gap:7,opacity:submitting?.6:1}}>
              <IconCheck/> {submitting ? (isAr?"جاري الرفع...":"Uploading...") : (isAr?"رفع المرفقات":"Upload Attachments")}
            </button>
          </>)}
          </>)}
        </div>
      </div>
    </div>
  );
  return ReactDOM.createPortal(modal, document.body);
}

// ─── ValCell ─────────────────────────────────────────────────────────────────
function ValCell({ value, type, bold, isAr }) {
  const num = Number(value || 0);
  const color = num === 0 ? "#94a3b8" : type === "purchases" ? "#16a34a" : "#0f172a";
  return (
    <span style={{
      color, fontFamily: "monospace", fontSize: 13, fontWeight: bold ? 700 : 500,
      width: NUM_COL_WIDTH, minWidth: NUM_COL_WIDTH, flexShrink: 0,
      textAlign: "right", direction: "ltr", display: "block",
      marginInlineEnd: isAr ? 0 : 8,
    }}>
      {num !== 0 ? fmt(num) : "0.00"}
    </span>
  );
}

// ─── NetNum ─────────────────────────────────────────────────────────────────
function NetNum({ value, color }) {
  return (
    <span style={{
      fontFamily: "monospace", fontSize: 13, fontWeight: 700,
      width: NUM_COL_WIDTH, minWidth: NUM_COL_WIDTH, flexShrink: 0,
      textAlign: "right", direction: "ltr", color,
    }}>
      {value !== 0 ? fmt(Math.abs(value)) : "0.00"}
    </span>
  );
}

// ─── InvoicesPopup ────────────────────────────────────────────────────────────
function InvoicesPopup({ invoices, title, isAr, type, currency, onClose, showVat = false }) {
  const isPurchases = type === "purchases";
  const isEmpty = !invoices || invoices.length === 0;

  const getNet = (inv) => {
    if (inv.total_amount != null) return Number(inv.total_amount);
    if (inv.net_amount != null) return Number(inv.net_amount);
    if (inv.inv_details_sum_product_net_total != null) return Number(inv.inv_details_sum_product_net_total);
    return null;
  };
  const getVat = (inv) => {
    if (inv.vat_amount != null) return Number(inv.vat_amount);
    if (inv.inv_details_sum_product_vat != null) return Number(inv.inv_details_sum_product_vat);
    return null;
  };
  const hasNet = invoices?.some(
    inv => inv.total_amount != null || inv.net_amount != null || "inv_details_sum_product_net_total" in inv
  );
  const hasVat = showVat || invoices?.some(inv => getVat(inv) != null && getVat(inv) !== 0);

  function exportPopupExcel() {
    if (!invoices || invoices.length === 0) return;
    const headers = ["#", isAr ? "رقم الفاتورة" : "Invoice No.", isAr ? "تاريخ الفاتورة" : "Invoice Date"];
    if (hasNet) headers.push(isAr ? "مبلغ الفاتورة" : "Invoice Amount");
    if (hasVat) headers.push(isAr ? "مبلغ الضريبة" : "VAT Amount");
    const dataRows = invoices.map((inv, i) => {
      const parts = (inv.inv_date ? inv.inv_date.split(" ")[0] : "").split("-");
      const dispDate = parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : "—";
      const row = [i + 1, inv.inv_no ?? "—", dispDate];
      if (hasNet) row.push(getNet(inv) != null ? fmt(getNet(inv)) : "—");
      if (hasVat) row.push(getVat(inv) != null ? fmt(getVat(inv)) : "—");
      return row;
    });
    const totalRow = [isAr ? `الإجمالي (${invoices.length} فاتورة)` : `Total (${invoices.length} invoices)`, "", ""];
    if (hasNet) totalRow.push(fmt(invoices.reduce((s, inv) => s + (getNet(inv) ?? 0), 0)));
    if (hasVat) totalRow.push(fmt(invoices.reduce((s, inv) => s + (getVat(inv) ?? 0), 0)));
    const allRows = [headers, ...dataRows, totalRow];
    const csv = allRows.map(r => r.map(c => `"${String(c ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `invoices_${Date.now()}.csv`; a.click();
    URL.revokeObjectURL(url);
  }

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  const modal = (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 99999,
        background: "rgba(15,23,42,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 10,
          width: "96%",
          maxWidth: 960,
          maxHeight: "92vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 32px rgba(0,0,0,.2)",
          direction: isAr ? "rtl" : "ltr",
          fontFamily: "'Cairo',sans-serif",
          animation: "fadeUp .18s ease forwards",
        }}
      >
        {/* header */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "12px 16px", borderBottom: "1px solid #e2e8f0",
          background: "#f8fafc", borderRadius: "10px 10px 0 0", flexShrink: 0,
          gap: 8,
        }}>
          <span style={{ fontWeight: 700, fontSize: 13, color: "#0f172a", flex: 1, minWidth: 0 }}>
            {title}
          </span>
          <span style={{ fontSize: 11, color: "#64748b", whiteSpace: "nowrap" }}>
            {isAr ? "العملة:" : "Currency:"} {currency}
          </span>
          {!isEmpty && (
            <button
              onClick={exportPopupExcel}
              style={{
                background: "#fff", border: "1px solid #cbd5e1", borderRadius: 6,
                padding: "5px 12px", color: "#1e293b", fontSize: 12,
                cursor: "pointer", display: "flex", alignItems: "center", gap: 5,
                fontFamily: "'Cairo',sans-serif", whiteSpace: "nowrap",
                boxShadow: "0 1px 2px rgba(0,0,0,.05)", flexShrink: 0,
              }}
            >
              <IconDownload /> {isAr ? "تصدير إكسل" : "Export Excel"}
            </button>
          )}
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", fontSize: 20, lineHeight: 1, padding: "0 4px", marginInlineStart: 4, flexShrink: 0 }}>×</button>
        </div>
        {/* body */}
        <div style={{ overflowY: "auto", flex: 1 }}>
          {isEmpty ? (
            <div style={{ padding: 40, textAlign: "center", color: "#94a3b8", fontSize: 13 }}>
              {isAr ? "لا توجد فواتير في هذه الفترة" : "No invoices found for this period"}
            </div>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "#f1f5f9", borderBottom: "1px solid #e2e8f0", position: "sticky", top: 0 }}>
                  <th style={{ padding: "9px 14px", textAlign: isAr ? "right" : "left", color: "#475569", fontWeight: 700, fontSize: 12 }}>#</th>
                  <th style={{ padding: "9px 14px", textAlign: isAr ? "right" : "left", color: "#475569", fontWeight: 700, fontSize: 12, whiteSpace: "nowrap" }}>
                    {isAr ? "رقم الفاتورة" : "Invoice No."}
                  </th>
                  <th style={{ padding: "9px 14px", textAlign: isAr ? "right" : "left", color: "#475569", fontWeight: 700, fontSize: 12, whiteSpace: "nowrap" }}>
                    {isAr ? "تاريخ الفاتورة" : "Invoice Date"}
                  </th>
                  {hasNet && (
                    <th style={{ padding: "9px 14px", textAlign: "right", color: "#475569", fontWeight: 700, fontSize: 12, whiteSpace: "nowrap", direction: "ltr" }}>
                      {isAr ? "مبلغ الفاتورة" : "Invoice Amount"}
                    </th>
                  )}
                  {hasVat && (
                    <th style={{ padding: "9px 14px", textAlign: "right", color: "#475569", fontWeight: 700, fontSize: 12, whiteSpace: "nowrap", direction: "ltr" }}>
                      {isAr ? "مبلغ الضريبة" : "VAT Amount"}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv, i) => {
                  const netAmt = getNet(inv);
                  const vatAmt = getVat(inv);
                  const parts = (inv.inv_date ? inv.inv_date.split(" ")[0] : "").split("-");
                  const dispDate = parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : "—";
                  return (
                    <tr key={inv.id} style={{ borderBottom: "1px solid #f1f5f9", background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                      <td style={{ padding: "8px 14px", color: "#94a3b8", fontSize: 12 }}>{i + 1}</td>
                      <td style={{ padding: "8px 14px", color: "#0f172a", fontWeight: 600 }}>{inv.inv_no ?? "—"}</td>
                      <td style={{ padding: "8px 14px", color: "#475569", direction: "ltr", textAlign: isAr ? "right" : "left" }}>{dispDate}</td>
                      {hasNet && (
                        <td style={{ padding: "8px 14px", textAlign: "right", direction: "ltr", fontFamily: "monospace", fontWeight: 600, color: netAmt == null ? "#94a3b8" : isPurchases ? "#15803d" : "#0f172a" }}>
                          {netAmt != null ? fmt(netAmt) : "—"}
                        </td>
                      )}
                      {hasVat && (
                        <td style={{ padding: "8px 14px", textAlign: "right", direction: "ltr", fontFamily: "monospace", fontWeight: 600, color: vatAmt == null ? "#94a3b8" : isPurchases ? "#15803d" : "#0f172a" }}>
                          {vatAmt != null ? fmt(vatAmt) : "—"}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ borderTop: "2px solid #e2e8f0", background: "#f8fafc" }}>
                  <td colSpan={3} style={{ padding: "9px 14px", fontWeight: 400, fontSize: 13, color: "#334155" }}>
                    {isAr ? `عدد الفواتير: ${invoices.length}` : `Invoice Count: ${invoices.length}`}
                  </td>
                  {hasNet && (
                    <td style={{ padding: "9px 14px", textAlign: "right", direction: "ltr", fontFamily: "monospace", fontWeight: 700, color: isPurchases ? "#15803d" : "#0f172a", fontSize: 13 }}>
                      {fmt(invoices.reduce((s, inv) => s + (getNet(inv) ?? 0), 0))}
                    </td>
                  )}
                  {hasVat && (
                    <td style={{ padding: "9px 14px", textAlign: "right", direction: "ltr", fontFamily: "monospace", fontWeight: 700, color: isPurchases ? "#15803d" : "#0f172a", fontSize: 13 }}>
                      {fmt(invoices.reduce((s, inv) => s + (getVat(inv) ?? 0), 0))}
                    </td>
                  )}
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
}

// ─── Row ─────────────────────────────────────────────────────────────────────
const Q_ZONE = 36;

function Row({ label, labelEn, value, highlighted, isAr, type = "sales", invoices, sectionTitle, subInvoices, currency, showVat = false }) {
  const display = isAr ? label : (labelEn || label);
  const [popupOpen, setPopupOpen] = useState(false);
  const hasSubInvoices = !highlighted && subInvoices && subInvoices.length > 0;

  return (
    <>
      <div style={{
        display: "flex", alignItems: "center", gap: 8,
        padding: highlighted ? "11px 0" : "8px 0",
        paddingInlineStart: highlighted ? 18 : 36,
        paddingInlineEnd: Q_ZONE,
        background: highlighted ? "#e8edf2" : "transparent",
        borderBottom: "1px solid #e8edf2",
        position: "relative",
        direction: isAr ? "rtl" : "ltr",
      }}>
        <span style={{
          flex: 1, minWidth: 0,
          color: highlighted ? "#0f172a" : "#334155",
          fontWeight: highlighted ? 700 : 400,
          fontSize: highlighted ? 13 : 12,
        }}>
          {display}
        </span>
        <ValCell value={value} type={type} bold={highlighted} isAr={isAr} />

        {!highlighted && subInvoices !== undefined && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setPopupOpen(true);
            }}
            style={{
              position: "absolute",
              insetInlineEnd: 7,
              top: "50%",
              transform: "translateY(-50%)",
              background: hasSubInvoices
                ? (type === "purchases" ? "#dcfce7" : "#dbeafe")
                : "#f1f5f9",
              border: `1px solid ${hasSubInvoices
                ? (type === "purchases" ? "#86efac" : "#93c5fd")
                : "#e2e8f0"}`,
              borderRadius: "50%",
              width: 16, height: 16,
              cursor: "pointer",
              color: hasSubInvoices
                ? (type === "purchases" ? "#15803d" : "#1d4ed8")
                : "#94a3b8",
              fontSize: 10, fontWeight: 900, lineHeight: 1,
              padding: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontFamily: "serif",
              zIndex: 10,
              pointerEvents: "all",
            }}
          >
            ?
          </button>
        )}
      </div>

      {popupOpen && (
        <InvoicesPopup
          invoices={subInvoices}
          title={sectionTitle || display}
          isAr={isAr}
          type={type}
          currency={currency}
          showVat={showVat}
          onClose={() => setPopupOpen(false)}
        />
      )}
    </>
  );
}

// ─── Section ─────────────────────────────────────────────────────────────────
function Section({ title, titleEn, total, rows, isAr, type = "sales", invoices, invoicesZero, invoicesStandard, zeroRowIndex = 2, currency }) {
  return (
    <div style={{ background: "#fff", borderRadius: 6, marginBottom: 12, overflow: "hidden", border: "1px solid #d1d5db" }}>
      <Row label={title} labelEn={titleEn} value={total} highlighted isAr={isAr} type={type} invoices={invoices} sectionTitle={isAr ? title : titleEn} currency={currency} />
      {rows.map((r, i) => {
        let subInvoices = undefined;
        if (i === 0 && invoicesStandard !== undefined) subInvoices = invoicesStandard;
        if (i === zeroRowIndex && invoicesZero !== undefined) subInvoices = invoicesZero;
        return (
          <Row
            key={i}
            label={r.label}
            labelEn={r.labelEn}
            value={r.value}
            isAr={isAr}
            type={type}
            subInvoices={subInvoices}
            sectionTitle={isAr ? r.label : r.labelEn}
            currency={currency}
            showVat={i === 0}
          />
        );
      })}
    </div>
  );
}

// ─── DropdownItem ─────────────────────────────────────────────────────────────
function DropdownItem({ option, selected, onSelect, isAr }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={() => onSelect(option)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding:      "10px 16px",
        cursor:       "pointer",
        color:        selected ? "#2563eb" : "#334155",
        background:   selected ? "#eff6ff" : hovered ? "#f1f5f9" : "transparent",
        fontSize:     13,
        borderBottom: "1px solid #f1f5f9",
        direction:    isAr ? "rtl" : "ltr",
        fontFamily:   "'Cairo',sans-serif",
        textAlign:    isAr ? "right" : "left",
        fontWeight:   selected ? 600 : 400,
        transition:   "background .12s",
      }}
    >
      {option.label}
    </div>
  );
}

// ─── Dropdown ────────────────────────────────────────────────────────────────
function Dropdown({ btnLabel, options, selectedId, onSelect, disabled, isAr }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button onClick={() => !disabled && setOpen(o => !o)} style={{
        background: disabled ? "#f8fafc" : "#fff", border: "1px solid #cbd5e1", borderRadius: 6,
        padding: "6px 14px", color: disabled ? "#94a3b8" : "#1e293b", fontSize: 13,
        cursor: disabled ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 6,
        fontFamily: "'Cairo',sans-serif", whiteSpace: "nowrap",
        boxShadow: "0 1px 2px rgba(0,0,0,.05)", opacity: disabled ? 0.6 : 1,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>{btnLabel}</div>
        {!disabled && <span style={{ color: "#94a3b8", fontSize: 11 }}>▾</span>}
      </button>
      {open && !disabled && (
        <div style={{
          position: "absolute", top: "110%", background: "#fff", border: "1px solid #cbd5e1",
          borderRadius: 8, minWidth: 260, zIndex: 20, overflow: "hidden",
          boxShadow: "0 8px 32px rgba(0,0,0,.1)", ...(isAr ? { right: 0 } : { left: 0 }),
        }}>
          {options.map(o => (
            <DropdownItem
              key={o.id} option={o} selected={o.id === selectedId}
              onSelect={(opt) => { onSelect(opt); setOpen(false); }}
              isAr={isAr}
            />
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Footer Component (Reusable) ─────────────────────────────────────────────
function ReportFooter({ isAr, isPrint = false }) {
  const logoStyle = {
    height: isPrint ? 22 : 32,
    width: "auto",
    objectFit: "contain",
    maxWidth: "100%",
    display: "block",
  };
  const containerStyle = {
    marginTop: "auto",
    padding: isPrint ? "8px 10px" : "20px 10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: isPrint ? 4 : 10,
    color: "#1e293b",
    fontSize: isPrint ? 10 : 12,
    textAlign: "center",
    direction: "rtl",
    fontFamily: "'Cairo',sans-serif",
    pageBreakInside: "avoid",
    breakInside: "avoid",
  };
  const textStyle = {
    fontWeight: 600,
    color: "#1e293b",
    fontSize: isPrint ? 9 : 12,
    margin: 0,
    lineHeight: isPrint ? 1.2 : 1.4,
  };
  const linkStyle = {
    color: "#1e293b",
    textDecoration: "none",
    direction: "ltr",
    fontSize: isPrint ? 9 : 11,
    fontWeight: 500,
  };

  return (
    <div style={containerStyle}>
      <img 
        src="/logo-dark-ar.webp" 
        alt="Absat ERP Logo" 
        style={logoStyle}
        onError={(e) => { e.target.style.display = 'none'; }} 
      />
      <div style={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center" }}>
        <span style={textStyle}>أنشئ بواسطة نظام أبسط أعمال</span>
        <a href="http://www.absat-erp.com" target="_blank" rel="noopener noreferrer" style={linkStyle}>
          http://www.absat-erp.com
        </a>
      </div>
    </div>
  );
}

// ─── Main ────────────────────────────────────────────────────────────────────
export default function VATFilingReport() {
  const [taxes,         setTaxes]         = useState([]);
  const [selectedTax,   setSelectedTax]   = useState(null);
  const [period,        setPeriod]        = useState("this_quarter");
  const [customFrom,    setCustomFrom]    = useState("");
  const [customTo,      setCustomTo]      = useState("");
  const [dateRange,     setDateRange]     = useState(computeDateRange("this_quarter"));
  const [data,          setData]          = useState(null);
  const [purchasesData, setPurchasesData] = useState(null);
  const [loading,       setLoading]       = useState(false);
  const [taxLoading,    setTaxLoading]    = useState(false);
  const [error,         setError]         = useState(null);
  const [showFilingModal, setShowFilingModal] = useState(false);
  const [filingRefreshKey, setFilingRefreshKey] = useState(0);

  const { langSelected } = useLang();
  const lang = useMemo(
    () => (langSelected?.value || "ar").toLowerCase().startsWith("ar") ? "ar" : "en",
    [langSelected]
  );
  const isAr     = lang === "ar";
  const currencyCode = useMemo(() => getUserCurrencyCode(), []);
  const currency = useMemo(() => getCurrencyDisplay(currencyCode, isAr), [currencyCode, isAr]);

  useEffect(() => {
    setTaxes(prev => prev.map(t => ({ ...t, label: lang === "ar" ? t.labelAr : t.labelEn })));
    setSelectedTax(prev => prev?.raw ? { ...prev, label: lang === "ar" ? prev.labelAr : prev.labelEn } : prev);
  }, [lang]);

  useEffect(() => {
    const tenantId = getTenantId(), companyId = getCompanyId(), branchId = getBranchId();
    if (!tenantId || !companyId || !branchId) {
      setError(`Session error — tenant:${tenantId} | company:${companyId} | branch:${branchId}`);
      return;
    }
    setTaxLoading(true);
    fetch(`${BASE_URL}/sales/taxes/${tenantId}/${companyId}/${branchId}`)
      .then(r => r.json())
      .then(json => {
        const raw  = Array.isArray(json.data) ? json.data : (Array.isArray(json) ? json : []);
        const list = raw.map(item => normalizeTax(item, lang));
        setTaxes(list);
        const def = list.find(t => Number(t.value) === 15) ?? list[0] ?? null;
        if (def) setSelectedTax(def);
      })
      .catch(e => setError(`Failed to load taxes: ${e.message}`))
      .finally(() => setTaxLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchReport = useCallback(async (range) => {
    if (!selectedTax) return;
    const tenantId = getTenantId(), companyId = getCompanyId();
    if (!tenantId || !companyId) return;
    setLoading(true); setError(null);
    try {
      const [sRes, pRes] = await Promise.all([
        fetch(`${BASE_URL}/sales/invoices-taxes/${tenantId}/${companyId}/${range.from}/${range.to}/${selectedTax.id}`),
        fetch(`${BASE_URL}/purchases/invoices-taxes/${tenantId}/${companyId}/${range.from}/${range.to}/${selectedTax.id}`),
      ]);
      const [sJson, pJson] = await Promise.all([sRes.json(), pRes.json()]);
      if (sJson.status === 1) setData(sJson.data);
      else setError(sJson.message || "Sales response error");
      setPurchasesData(pJson.status === 1 ? pJson.data : null);
    } catch (e) {
      setError(`Server error: ${e.message}`);
    } finally {
      setLoading(false);
    }
  }, [selectedTax]);

  useEffect(() => {
    if (!selectedTax || period === "custom") return;
    const r = computeDateRange(period);
    setDateRange(r);
    fetchReport(r);
  }, [period, selectedTax, fetchReport]);

  function handleCustomFetch() {
    if (!customFrom || !customTo) return;
    const r = { from: customFrom, to: customTo };
    setDateRange(r); fetchReport(r);
  }

  const periodLabel = isAr
    ? (PERIOD_OPTIONS.find(o => o.value === period)?.label ?? "—")
    : (PERIOD_OPTIONS.find(o => o.value === period)?.labelEn ?? "—");
  const periodNorm = PERIOD_OPTIONS.map(o => ({ id: o.value, label: isAr ? o.label : o.labelEn }));
  const taxNorm    = taxes.map(t => ({ id: t.id, label: t.label }));

  const now = new Date();
  const headerDate = isAr
    ? `${now.getFullYear()} ${now.toLocaleString("ar-EG", { month: "long" })}`
    : now.toLocaleString("en-US", { month: "long", year: "numeric" });
  const isCustom = period === "custom";

  // ── Derived values ─────────────────────────────────────────────────────────
  // ── Normalize invoices_total: API may return object {1:{...}, 2:{...}} or array ─
  function toInvArr(v) {
    if (Array.isArray(v)) return v;
    if (v && typeof v === "object") return Object.values(v);
    return [];
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const sd = useMemo(() => data ?? {}, [data]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const pd = useMemo(() => purchasesData ?? {}, [purchasesData]);
  const rateLabel = selectedTax?.value != null ? `${selectedTax.value}%` : "";

  // ── Invoice arrays ──────────────────────────────────────────────────────────
  const sInvTotal   = useMemo(() => toInvArr(sd.invoices_total),      [sd]);
  const sInvZero    = useMemo(() => toInvArr(sd.invoices_tax_zero),    [sd]);
  const sInvExempt  = useMemo(() => toInvArr(sd.invoices_tax_exempt),  [sd]);
  const sInvVat     = useMemo(() => Array.isArray(sd.invoices_vat) ? sd.invoices_vat : [], [sd]);

  const pInvTotal   = useMemo(() => toInvArr(pd.invoices_total),      [pd]);
  const pInvZero    = useMemo(() => toInvArr(pd.invoices_tax_zero),    [pd]);
  const pInvExempt  = useMemo(() => toInvArr(pd.invoices_tax_exempt),  [pd]);
  const pInvVat     = useMemo(() => Array.isArray(pd.invoices_vat) ? pd.invoices_vat : [], [pd]);

  // ── الفواتير الفريدة بدمج invoices_total + invoices_vat (الأولوية لـ invoices_total) ─
  // السيرفر أحياناً يبعت invoices_total فاضية وكل الفواتير في invoices_vat
  const sInvStandardArr = useMemo(() => {
    if (sInvTotal.length > 0) return sInvTotal;
    // نستثني الفواتير الموجودة في exempt وzero عشان ما نكررش
    const exemptIds = new Set([...sInvExempt, ...sInvZero].map(i => i.id));
    return sInvVat.filter(i => !exemptIds.has(i.id));
  }, [sInvTotal, sInvVat, sInvExempt, sInvZero]);

  const pInvStandardArr = useMemo(() => {
    if (pInvTotal.length > 0) return pInvTotal;
    const exemptIds = new Set([...pInvExempt, ...pInvZero].map(i => i.id));
    return pInvVat.filter(i => !exemptIds.has(i.id));
  }, [pInvTotal, pInvVat, pInvExempt, pInvZero]);

  // ── Calculated values ───────────────────────────────────────────────────────
  // الصف 1 — الخاضعة للضريبة الأساسية (أساسي)
  const s_standard = useMemo(() => sInvStandardArr.reduce((s,i) => s + Number(i.total_amount || 0), 0), [sInvStandardArr]);
  const p_standard = useMemo(() => pInvStandardArr.reduce((s,i) => s + Number(i.total_amount || 0), 0), [pInvStandardArr]);

  // الصف 3 — نسبة صفرية
  const s_zero     = useMemo(() => sInvZero.reduce((s,i)   => s + Number(i.total_amount || 0), 0), [sInvZero]);
  const p_zero     = useMemo(() => pInvZero.reduce((s,i)   => s + Number(i.total_amount || 0), 0), [pInvZero]);

  // الصف 5 — معفاة
  const s_exempt   = useMemo(() => sInvExempt.reduce((s,i) => s + Number(i.total_amount || 0), 0), [sInvExempt]);
  const p_exempt   = useMemo(() => pInvExempt.reduce((s,i) => s + Number(i.total_amount || 0), 0), [pInvExempt]);

  // الصف 6/12 — الإجمالي: grand_total من الـ API أو نحسبه يدوياً لو 0
  const s_net = useMemo(() => {
    const g = Number(sd.grand_total || 0);
    if (g !== 0) return g;
    return s_standard + s_zero + s_exempt;
  }, [sd, s_standard, s_zero, s_exempt]);

  const p_net = useMemo(() => {
    const g = Number(pd.grand_total || 0);
    if (g !== 0) return g;
    return p_standard + p_zero + p_exempt;
  }, [pd, p_standard, p_zero, p_exempt]);

  // الضريبة — grand_vat من الـ API أو نحسبها من invoices_vat
  const s_tax_std = useMemo(() => {
    const g = Number(sd.grand_vat || 0);
    if (g !== 0) return g;
    return sInvVat.reduce((s,i) => s + Number(i.vat_amount || 0), 0);
  }, [sd, sInvVat]);

  const p_tax_std = useMemo(() => {
    const g = Number(pd.grand_vat || 0);
    if (g !== 0) return g;
    return pInvVat.reduce((s,i) => s + Number(i.vat_amount || 0), 0);
  }, [pd, pInvVat]);

  const s_tax_net   = s_tax_std;
  const p_tax_net   = p_tax_std;
  // net_vat_due يُحسب من القيم المحسوبة (مجموع الصفوف)
  const net_vat_due = s_tax_std - p_tax_std;

  // ── Merge invoices for detail popup ────────────────────────────────────────
  function mergeInvoices(invStandard, invZero, invExempt, invVat) {
    const map = new Map();
    [...invStandard, ...invZero, ...invExempt].forEach(inv => map.set(inv.id, { ...inv }));
    invVat.forEach(inv => {
      if (map.has(inv.id)) Object.assign(map.get(inv.id), inv);
      else map.set(inv.id, { ...inv });
    });
    return Array.from(map.values());
  }
  const sMerged = useMemo(() => mergeInvoices(sInvStandardArr, sInvZero, sInvExempt, sInvVat), [sInvStandardArr, sInvZero, sInvExempt, sInvVat]);
  const pMerged = useMemo(() => mergeInvoices(pInvStandardArr, pInvZero, pInvExempt, pInvVat), [pInvStandardArr, pInvZero, pInvExempt, pInvVat]);

  // للبوب آب (علامة الاستفهام)
  const sInvoicesVatArr    = sInvVat;
  const pInvoicesVatArr    = pInvVat;
  const sInvoicesStandard  = sInvStandardArr;
  const sInvoicesZero      = sInvZero;
  const pInvoicesStandard  = pInvStandardArr;
  const pInvoicesZero      = pInvZero;

  // صف الإجمالي = مجموع الصفوف الخمسة السابقة (وليس قيمة API مباشرة)
  const s_net_computed      = s_standard + 0 + s_zero + 0 + s_exempt;
  const s_tax_net_computed  = s_tax_std  + 0 + 0      + 0 + 0;
  const p_net_computed      = p_standard + 0 + 0      + p_zero + p_exempt;
  const p_tax_net_computed  = p_tax_std  + 0 + 0      + 0      + 0;

  const salesBaseRows = [
    { label:`1. المبيعات الخاضعة للضريبة الأساسية ${rateLabel} (أساسي)`, labelEn:`1. Standard Rated ${rateLabel} (Base)`,                 value:s_standard        },
    { label:`2. المبيعات الخاصة للمحليين (أساسي)`,                       labelEn:`2. Special Sales to Locals (Base)`,                     value:0                 },
    { label:`3. المبيعات المحلية الخاضعة للنسبة الصفرية (أساسي)`,        labelEn:`3. Local Sales Subject to 0% (Base)`,                   value:s_zero            },
    { label:`4. مبيعات التصدير (أساسي)`,                                 labelEn:`4. Export Sales (Base)`,                                value:0                 },
    { label:`5. المبيعات المعفاة من الضريبة (أساسي)`,                    labelEn:`5. Exempt Sales (Base)`,                                value:s_exempt          },
    { label:`6. إجمالي المبيعات (أساسي)`,                                labelEn:`6. Net Sales (Base)`,                                   value:s_net_computed    },
  ];
  const salesTaxRows = [
    { label:`1. المبيعات الخاضعة للضريبة الأساسية ${rateLabel} (ضريبة)`,labelEn:`1. Standard Rated ${rateLabel} (Tax)`,                  value:s_tax_std         },
    { label:`2. المبيعات الخاصة للمحليين (ضريبة)`,                       labelEn:`2. Special Sales to Locals (Tax)`,                      value:0                 },
    { label:`3. المبيعات المحلية الخاضعة للنسبة الصفرية (ضريبة)`,        labelEn:`3. Local Sales Subject to 0% (Tax)`,                    value:0                 },
    { label:`4. مبيعات التصدير (ضريبة)`,                                 labelEn:`4. Export Sales (Tax)`,                                 value:0                 },
    { label:`5. المبيعات المعفاة من الضريبة (ضريبة)`,                    labelEn:`5. Exempt Sales (Tax)`,                                 value:0                 },
    { label:`6. إجمالي المبيعات (ضريبة)`,                                labelEn:`6. Net Sales (Tax)`,                                    value:s_tax_net_computed },
  ];
  const purchasesBaseRows = [
    { label:`7. المشتريات الخاضعة للضريبة الأساسية ${rateLabel} (أساسي)`,labelEn:`7. Standard rated ${rateLabel} Purchases (Base)`,       value:p_standard        },
    { label:`8. الاستيرادات الخاضعة للضريبة تُدفع في الجمارك (أساسي)`,  labelEn:`8. Taxable Imports ${rateLabel} Paid to Customs (Base)`,value:0                 },
    { label:`9. الاستيرادات بآلية الاحتساب العكسي (أساسي)`,              labelEn:`9. Imports subject to reverse charge mechanism (Base)`, value:0                 },
    { label:`10. المشتريات الخاضعة للنسبة الصفرية (أساسي)`,              labelEn:`10. Zero Rated Purchases (Base)`,                       value:p_zero            },
    { label:`11. المشتريات المعفاة من الضريبة (أساسي)`,                  labelEn:`11. Exempt Purchases (Base)`,                           value:p_exempt          },
    { label:`12. إجمالي المشتريات (أساسي)`,                              labelEn:`12. Net Purchases (Base)`,                              value:p_net_computed    },
  ];
  const purchasesTaxRows = [
    { label:`7. المشتريات الخاضعة للضريبة الأساسية ${rateLabel} (ضريبة)`,labelEn:`7. Standard rated ${rateLabel} Purchases (Tax)`,        value:p_tax_std         },
    { label:`8. الاستيرادات الخاضعة للضريبة تُدفع في الجمارك (ضريبة)`,  labelEn:`8. Taxable Imports ${rateLabel} Paid to Customs (Tax)`, value:0                 },
    { label:`9. الاستيرادات بآلية الاحتساب العكسي (ضريبة)`,              labelEn:`9. Imports subject to reverse charge mechanism (Tax)`,  value:0                 },
    { label:`10. المشتريات الخاضعة للنسبة الصفرية (ضريبة)`,              labelEn:`10. Zero Rated Purchases (Tax)`,                        value:0                 },
    { label:`11. المشتريات المعفاة من الضريبة (ضريبة)`,                  labelEn:`11. Exempt Purchases (Tax)`,                            value:0                 },
    { label:`12. إجمالي المشتريات (ضريبة)`,                              labelEn:`12. Net Purchases (Tax)`,                               value:p_tax_net_computed },
  ];

  function doExport() {
    const bi = (ar, en) => isAr ? ar : en;
    const rows = [
      [isAr?"تقرير الإقرار الضريبي":"VAT Filing Report"],
      [isAr?"الفترة:":"Period:", periodLabel],
      [isAr?"من:":"From:", displayDate(dateRange.from), isAr?"إلى:":"To:", displayDate(dateRange.to)],
      [isAr?"الضريبة:":"Tax:", selectedTax?.label ?? ""],
      [],
      [bi("البند","Item"), bi("الرصيد","Balance")],
      [bi(`${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المبيعات والمخرجات الأخرى (أساسي)`,`${selectedTax?.labelEn ?? "VAT"} on Sales and all other Outputs (Base)`), fmt(s_net)],
      ...salesBaseRows.map(r=>[bi(r.label,r.labelEn), fmt(r.value)]),
      [],
      [bi(`${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المبيعات والمخرجات الأخرى (ضريبة)`,`${selectedTax?.labelEn ?? "VAT"} on Sales and all other Outputs (Tax)`), fmt(s_tax_net)],
      ...salesTaxRows.map(r=>[bi(r.label,r.labelEn), fmt(r.value)]),
      [],
      [bi(`${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المصروفات والمدخلات الأخرى (أساسي)`,`${selectedTax?.labelEn ?? "VAT"} on Expenses and all other Inputs (Base)`), fmt(p_net)],
      ...purchasesBaseRows.map(r=>[bi(r.label,r.labelEn), fmt(r.value)]),
      [],
      [bi(`${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المصروفات والمدخلات الأخرى (ضريبة)`,`${selectedTax?.labelEn ?? "VAT"} on Expenses and all other Inputs (Tax)`), fmt(p_tax_net)],
      ...purchasesTaxRows.map(r=>[bi(r.label,r.labelEn), fmt(r.value)]),
      [],
      [bi("صافي ضريبة القيمة المضافة المستحقة","Net VAT Due"), fmt(net_vat_due)],
      [bi("إجمالي قيمة الضريبة المستحقة للفترة","Total value of due tax for the period"), fmt(s_tax_net)],
      [bi("إجمالي قيمة الضريبة القابلة للاسترداد","Total value of recoverable tax for the period"), fmt(p_tax_net)],
      [bi("صافي ضريبة القيمة المضافة المستحقة (أو المستردة) للفترة","Net VAT due (or reclaimed) for the period"), fmt(Math.abs(net_vat_due))],
    ];
    const csv  = rows.map(r=>r.map(c=>`"${String(c??"").replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob = new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8;"});
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href=url; a.download=`VAT_Report_${dateRange.from}_${dateRange.to}.csv`; a.click();
    URL.revokeObjectURL(url);
  }

  function doPrint() {
    if (!data) return;
    const title = isAr ? "تقرير الإقرار الضريبي" : "VAT Filing Report";
    const sections = [
      {
        title: isAr ? `${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المبيعات والمخرجات الأخرى (أساسي)` : `${selectedTax?.labelEn ?? "VAT"} on Sales and all other Outputs (Base)`,
        total: s_net,
        rows: salesBaseRows,
        type: "sales",
      },
      {
        title: isAr ? `${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المبيعات والمخرجات الأخرى (ضريبة)` : `${selectedTax?.labelEn ?? "VAT"} on Sales and all other Outputs (Tax)`,
        total: s_tax_net,
        rows: salesTaxRows,
        type: "sales",
      },
      {
        title: isAr ? `${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المصروفات والمدخلات الأخرى (أساسي)` : `${selectedTax?.labelEn ?? "VAT"} on Expenses and all other Inputs (Base)`,
        total: p_net,
        rows: purchasesBaseRows,
        type: "purchases",
      },
      {
        title: isAr ? `${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المصروفات والمدخلات الأخرى (ضريبة)` : `${selectedTax?.labelEn ?? "VAT"} on Expenses and all other Inputs (Tax)`,
        total: p_tax_net,
        rows: purchasesTaxRows,
        type: "purchases",
      },
    ];
    const numCell = (value, type, bold = false) => {
      const num = Number(value || 0);
      const color = num === 0 ? "#94a3b8" : type === "purchases" ? "#16a34a" : "#0f172a";
      return `<span style="color:${color};font-family:monospace;font-size:10px;font-weight:${bold ? 700 : 500};width:${NUM_COL_WIDTH}px;min-width:${NUM_COL_WIDTH}px;flex-shrink:0;text-align:right;direction:ltr;display:block;">${num !== 0 ? fmt(num) : "0.00"}</span>`;
    };
    const netNum = (value, color) => `<span style="font-family:monospace;font-size:10px;font-weight:700;width:${NUM_COL_WIDTH}px;min-width:${NUM_COL_WIDTH}px;flex-shrink:0;text-align:right;direction:ltr;color:${color};display:block;">${value !== 0 ? fmt(Math.abs(value)) : "0.00"}</span>`;
    
    const footerHTML = `
      <div class="print-footer">
        <img src="/logo-dark-ar.webp" alt="Absat ERP Logo" style="height:22px;width:auto;object-fit:contain;max-width:100%;display:block;" onerror="this.style.display='none'" />
        <div style="display:flex;flex-direction:column;gap:2px;align-items:center;line-height:1.2;">
          <span style="font-weight:600;color:#1e293b;font-size:9px;margin:0;">أنشئ بواسطة نظام أبسط أعمال</span>
          <a href="http://www.absat-erp.com" style="color:#1e293b;text-decoration:none;direction:ltr;font-size:9px;font-weight:500;">http://www.absat-erp.com</a>
        </div>
      </div>
    `;

    const html = `<!DOCTYPE html>
<html dir="${isAr ? "rtl" : "ltr"}" lang="${lang}">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${title}</title>
  <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap" rel="stylesheet" />
  <style>
    *{box-sizing:border-box;margin:0;padding:0}
    html,body{background:#ffffff;color:#1e293b;font-family:'Cairo',sans-serif}
    body{padding:14px 18px}
    .report{width:100%;max-width:1120px;margin:0 auto}
    .header-block{border:1px solid #d1d5db;border-radius:6px;margin-bottom:14px;overflow:hidden}
    .header-top{display:flex;justify-content:center;align-items:center;padding:12px 16px;background:#f8fafc;border-bottom:2px solid #0f172a}
    .header-title{font-size:17px;font-weight:900;color:#0f172a;letter-spacing:.3px;text-align:center}
    .header-meta{display:flex;border-top:1px solid #e2e8f0}
    .meta-cell{flex:1;padding:9px 14px;border-inline-end:1px solid #e2e8f0;display:flex;flex-direction:column;gap:3px;background:#f8fafc}
    .meta-cell:last-child{border-inline-end:none}
    .meta-key{font-size:9px;color:#94a3b8;font-weight:600;letter-spacing:.4px}
    .meta-val{font-size:12px;font-weight:700;color:#1e293b}
    .meta-val.ltr{direction:ltr;text-align:start}
    .balance-wrap{display:flex;flex-direction:column;width:${NUM_COL_WIDTH}px;min-width:${NUM_COL_WIDTH}px;flex-shrink:0}
    .balance-date{background:#f1f5f9;border:1px solid #d1d5db;border-bottom:none;border-radius:4px 4px 0 0;padding:3px 6px;font-size:10px;color:#475569;text-align:center}
    .balance-label{background:#e2e8f0;border:1px solid #d1d5db;border-radius:0 0 4px 4px;padding:3px 6px;font-size:11px;font-weight:700;color:#374151;text-align:center}
    .col-header{display:flex;justify-content:flex-end;padding-bottom:4px}
    .section{background:#fff;border-radius:5px;margin-bottom:9px;overflow:hidden;border:1px solid #d1d5db;page-break-inside:avoid}
    .row{display:flex;align-items:center;gap:6px;padding:8px 0;padding-inline-start:28px;padding-inline-end:10px;border-bottom:1px solid #e8edf2}
    .row.head{padding:9px 0;padding-inline-start:12px;padding-inline-end:10px;background:#e8edf2}
    .row:last-child{border-bottom:none}
    .label{flex:1;min-width:0;color:#334155;font-size:12px}
    .head .label{color:#0f172a;font-size:13px;font-weight:700}
    .net{background:#fff;border-radius:5px;border:1px solid #d1d5db;overflow:hidden;page-break-inside:avoid;margin-bottom:9px}
    .net-row{display:flex;align-items:center;gap:6px;padding:8px 0;padding-inline-start:28px;padding-inline-end:10px;border-bottom:1px solid #e8edf2}
    .net-row.main{padding:9px 0;padding-inline-start:12px;padding-inline-end:10px;background:#e8edf2}
    .net-row:last-child{border-bottom:none}
    .net-label{flex:1;min-width:0;color:#334155;font-size:12px}
    .net-row.main .net-label{color:#0f172a;font-size:13px;font-weight:700}
    .net-row.strong .net-label{font-weight:600}
    .print-footer{padding:6px 10px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;color:#1e293b;font-size:10px;text-align:center;direction:rtl;font-family:'Cairo',sans-serif;}
    @page{size:A4 portrait;margin:8mm 8mm 9mm 8mm}
    @media print{
      html,body{width:100%}
      body{padding:0}
      .report{max-width:none;width:100%}
      .print-footer{position:fixed;bottom:0;left:0;right:0;background:#fff;margin:0;}
      *{-webkit-print-color-adjust:exact;print-color-adjust:exact}
    }
  </style>
</head>
<body>
  <div class="report">
    <div class="header-block">
      <div class="header-top">
        <div class="header-title">${title}</div>
      </div>
      <div class="header-meta">
        <div class="meta-cell">
          <span class="meta-key">${isAr ? "الفترة الضريبية" : "Tax Period"}</span>
          <span class="meta-val">${periodLabel}${isCustom && customFrom && customTo ? ` (${displayDate(customFrom)} \u2192 ${displayDate(customTo)})` : ""}</span>
        </div>
        <div class="meta-cell">
          <span class="meta-key">${isAr ? "نوع الضريبة" : "Tax Type"}</span>
          <span class="meta-val">${selectedTax?.label ?? "—"}</span>
        </div>
        <div class="meta-cell">
          <span class="meta-key">${isAr ? "من" : "From"}</span>
          <span class="meta-val ltr">${displayDate(dateRange.from)}</span>
        </div>
        <div class="meta-cell">
          <span class="meta-key">${isAr ? "إلى" : "To"}</span>
          <span class="meta-val ltr">${displayDate(dateRange.to)}</span>
        </div>
        <div class="meta-cell">
          <span class="meta-key">${isAr ? "العملة" : "Currency"}</span>
          <span class="meta-val">${currency}</span>
        </div>
        <div class="meta-cell">
          <span class="meta-key">${isAr ? "تاريخ الإصدار" : "Issued On"}</span>
          <span class="meta-val ltr">${new Date().toLocaleDateString("en-GB")}</span>
        </div>
      </div>
    </div>
    <div class="col-header">
      <div class="balance-wrap">
        <div class="balance-date">${displayDate(dateRange.from)} &mdash; ${displayDate(dateRange.to)}</div>
        <div class="balance-label">${isAr ? "الرصيد" : "Balance"}</div>
      </div>
    </div>
    ${sections.map(section => `
      <div class="section">
        <div class="row head">
          <span class="label">${section.title}</span>
          ${numCell(section.total, section.type, true)}
        </div>
        ${section.rows.map(row => `
          <div class="row">
            <span class="label">${isAr ? row.label : row.labelEn}</span>
            ${numCell(row.value, section.type)}
          </div>
        `).join("")}
      </div>
    `).join("")}
    <div class="net">
      <div class="net-row main">
        <span class="net-label">${isAr ? "صافي ضريبة القيمة المضافة المستحقة" : "Net VAT Due"}</span>
        ${netNum(net_vat_due, net_vat_due !== 0 ? "#0f172a" : "#94a3b8")}
      </div>
      <div class="net-row">
        <span class="net-label">${isAr ? "إجمالي قيمة الضريبة المستحقة للفترة" : "Total value of due tax for the period"}</span>
        ${netNum(s_tax_net, s_tax_net !== 0 ? "#0f172a" : "#94a3b8")}
      </div>
      <div class="net-row">
        <span class="net-label">${isAr ? "إجمالي قيمة الضريبة القابلة للاسترداد للفترة" : "Total value of recoverable tax for the period"}</span>
        ${netNum(p_tax_net, p_tax_net !== 0 ? "#16a34a" : "#94a3b8")}
      </div>
      <div class="net-row strong">
        <span class="net-label">${isAr ? "صافي ضريبة القيمة المضافة المستحقة (أو المستردة) للفترة" : "Net VAT due (or reclaimed) for the period"}</span>
        ${netNum(net_vat_due, net_vat_due > 0 ? "#2563eb" : net_vat_due < 0 ? "#16a34a" : "#94a3b8")}
      </div>
    </div>
    ${footerHTML}
  </div>
  <script>
    window.onload = () => {
      window.focus();
      window.print();
      window.onafterprint = () => window.close();
    };
  </script>
</body>
</html>`;
    const printWindow = window.open("", "_blank", "width=1280,height=900");
    if (!printWindow) return;
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
  }

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap" rel="stylesheet" />
      <style>{`
        *{box-sizing:border-box;margin:0;padding:0}
        body{background:#f0f2f5}
        @keyframes spin{to{transform:rotate(360deg)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
        .fade{animation:fadeUp .25s ease forwards}
        .run-btn{background:#2563eb;border:none;border-radius:6px;padding:6px 18px;color:#fff;font-size:13px;font-family:'Cairo',sans-serif;font-weight:700;cursor:pointer;transition:background .15s;white-space:nowrap;display:flex;align-items:center;gap:6px}
        .run-btn:hover{background:#1d4ed8}
        .run-btn:disabled{background:#94a3b8;cursor:not-allowed}
        .action-btn{background:#fff;border:1px solid #cbd5e1;border-radius:6px;padding:6px 14px;color:#1e293b;font-size:13px;font-family:'Cairo',sans-serif;cursor:pointer;display:flex;align-items:center;gap:6px;white-space:nowrap;box-shadow:0 1px 2px rgba(0,0,0,.05);transition:background .15s}
        .action-btn:hover{background:#f1f5f9}
        .action-btn:disabled{opacity:.5;cursor:not-allowed}
      `}</style>

      <div style={{minHeight:"100vh",background:"#f0f2f5",fontFamily:"'Cairo',sans-serif",direction:isAr?"rtl":"ltr",color:"#1e293b",display:"flex",flexDirection:"column"}}>

        {/* ── top bar ── */}
        <div style={{background:"#fff",borderBottom:"1px solid #e2e8f0",padding:"12px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10,position:"sticky",top:0,zIndex:5,boxShadow:"0 1px 3px rgba(0,0,0,.06)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{color:"#0f172a",display:"flex",alignItems:"center"}}><IconChart /></span>
            <span style={{fontWeight:800,fontSize:15,color:"#0f172a"}}>
              {isAr?"تقرير الإقرار الضريبي (SA)":"VAT Filing Report (SA)"}
            </span>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",direction:isAr?"rtl":"ltr"}}>
            <div style={{background:"#f1f5f9",border:"1px solid #cbd5e1",borderRadius:6,padding:"6px 12px",fontSize:13,color:"#475569",display:"flex",alignItems:"center",gap:6}}>
              <IconCalendar /> {headerDate}
            </div>
            <Dropdown
              btnLabel={<><IconCalendar /> {periodLabel}</>}
              options={periodNorm} selectedId={period}
              onSelect={o=>{setPeriod(o.id);setData(null);setPurchasesData(null);}}
              isAr={isAr}
            />
            {taxLoading ? (
              <span style={{color:"#64748b",fontSize:13,display:"flex",alignItems:"center",gap:6}}>
                <span style={{display:"inline-block",width:14,height:14,border:"2px solid #e2e8f0",borderTop:"2px solid #2563eb",borderRadius:"50%",animation:"spin .8s linear infinite"}} />
                {isAr?"جاري تحميل الضرائب...":"Loading taxes..."}
              </span>
            ) : taxes.length > 0 && (
              <Dropdown
                btnLabel={<><IconTag /> {selectedTax?.label ?? (isAr?"اختر الضريبة":"Select Tax")}</>}
                options={taxNorm} selectedId={selectedTax?.id}
                onSelect={t=>setSelectedTax(taxes.find(x=>x.id===t.id))}
                isAr={isAr}
              />
            )}
            <div style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:6,padding:"6px 12px",fontSize:13,color:"#2563eb",fontWeight:700}}>
              {currency}
            </div>
            {data && (
              <>
                <button className="action-btn" onClick={doExport}><IconDownload /> {isAr?"تصدير إكسل":"Export Excel"}</button>
                <button className="action-btn" onClick={doPrint}><IconPrint /> {isAr?"طباعة":"Print"}</button>
                <button
                  onClick={()=>setShowFilingModal(true)}
                  style={{background:"#251658",border:"1px solid #1a0f42",borderRadius:7,padding:"6px 16px",color:"#fff",fontSize:13,fontFamily:"'Cairo',sans-serif",fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",gap:7,boxShadow:"0 2px 10px rgba(37,22,88,.4)",transition:"background .15s"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#1a0f42"}
                  onMouseLeave={e=>e.currentTarget.style.background="#251658"}
                >
                  <IconStamp /> {isAr?"اعتماد الإقرار الضريبي":"Submit Tax Filing"}
                </button>
              </>
            )}
          </div>
        </div>

        {/* ── custom date bar ── */}
        {isCustom && (
          <div style={{background:"#fff",borderBottom:"1px solid #e2e8f0",padding:"10px 20px",display:"flex",gap:12,alignItems:"center",direction:isAr?"rtl":"ltr",flexWrap:"wrap"}}>
            <label style={{color:"#475569",fontSize:13}}>{isAr?"من:":"From:"}</label>
            <input type="date" value={customFrom} onChange={e=>setCustomFrom(e.target.value)}
              style={{background:"#fff",border:"1px solid #cbd5e1",borderRadius:6,padding:"6px 10px",color:"#1e293b",fontSize:13,direction:"ltr"}} />
            <label style={{color:"#475569",fontSize:13}}>{isAr?"إلى:":"To:"}</label>
            <input type="date" value={customTo} onChange={e=>setCustomTo(e.target.value)}
              style={{background:"#fff",border:"1px solid #cbd5e1",borderRadius:6,padding:"6px 10px",color:"#1e293b",fontSize:13,direction:"ltr"}} />
            <button className="run-btn" onClick={handleCustomFetch}
              disabled={!customFrom||!customTo||loading||!selectedTax}
              style={{marginInlineStart:"auto"}}>
              {loading?(isAr?"جاري التحميل...":"Loading..."):<><IconBolt />{isAr?" إعداد التقرير":" Generate Report"}</>}
            </button>
          </div>
        )}

        {/* ── Zatca Filings Bar ── */}
        <ZatcaFilingBar
          isAr={isAr}
          dateRange={dateRange}
          tenantId={getTenantId()}
          companyId={getCompanyId()}
          refreshKey={filingRefreshKey}
          onRefresh={()=>setFilingRefreshKey(k=>k+1)}
          salesInvoices={sInvStandardArr}
          purchasesInvoices={pInvStandardArr}
          periodLabel={periodLabel}
          salesData={data}
          purchasesData={purchasesData}
          taxRateLabel={selectedTax?.value != null ? `${selectedTax.value}%` : ""}
        />

        {/* ── sub-header ── */}
        <div style={{padding:"14px 20px 8px",display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div style={{background:"#f1f5f9",borderRadius:6,padding:"5px 14px",fontSize:13,fontWeight:700,color:"#334155"}}>
            {periodLabel}
            {isCustom && customFrom && customTo && (
              <span style={{fontWeight:400,color:"#64748b",marginInlineStart:8}}>
                ({displayDate(customFrom)} → {displayDate(customTo)})
              </span>
            )}
          </div>
          <div style={{display:"flex",flexDirection:"column",width:NUM_COL_WIDTH,minWidth:NUM_COL_WIDTH,flexShrink:0}}>
            <div style={{background:"#f1f5f9",border:"1px solid #d1d5db",borderBottom:"none",borderRadius:"6px 6px 0 0",padding:"4px 8px",fontSize:11,color:"#475569",textAlign:"center"}}>
              {`${displayDate(dateRange.from)} — ${displayDate(dateRange.to)}`}
            </div>
            <div style={{background:"#e2e8f0",border:"1px solid #d1d5db",borderRadius:"0 0 6px 6px",padding:"4px 8px",fontSize:12,fontWeight:700,color:"#374151",textAlign:"center"}}>
              {isAr?"الرصيد":"Balance"}
            </div>
          </div>
        </div>

        {/* ── body ── */}
        <div style={{padding:"4px 20px 0",flex:1,display:"flex",flexDirection:"column"}}>

          {error && (
            <div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"12px 16px",color:"#b91c1c",fontSize:13,marginBottom:16,direction:"ltr",wordBreak:"break-all",display:"flex",alignItems:"center",gap:8}}>
              <IconAlert /> {error}
            </div>
          )}

          {loading && (
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",padding:80,color:"#2563eb",gap:12,fontSize:14}}>
              <span style={{display:"inline-block",width:22,height:22,border:"3px solid #e2e8f0",borderTop:"3px solid #2563eb",borderRadius:"50%",animation:"spin .8s linear infinite"}} />
              {isAr?"جاري تحميل البيانات...":"Loading data..."}
            </div>
          )}

          {!loading && data && (
            <div className="fade">
              <Section title={`${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المبيعات والمخرجات الأخرى (أساسي)`}  titleEn={`${selectedTax?.labelEn ?? "VAT"} on Sales and all other Outputs (Base)`}     total={s_net}     rows={salesBaseRows}     isAr={isAr} type="sales"     invoices={sMerged} invoicesStandard={sInvoicesStandard} invoicesZero={sInvoicesZero} currency={currency} />
              <Section title={`${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المبيعات والمخرجات الأخرى (ضريبة)`}  titleEn={`${selectedTax?.labelEn ?? "VAT"} on Sales and all other Outputs (Tax)`}      total={s_tax_net}  rows={salesTaxRows}      isAr={isAr} type="sales"     invoices={sMerged} invoicesStandard={sInvoicesStandard} invoicesZero={sInvoicesZero} currency={currency} />
              <Section title={`${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المصروفات والمدخلات الأخرى (أساسي)`} titleEn={`${selectedTax?.labelEn ?? "VAT"} on Expenses and all other Inputs (Base)`}   total={p_net}     rows={purchasesBaseRows} isAr={isAr} type="purchases" invoices={pMerged} invoicesStandard={pInvoicesStandard} invoicesZero={pInvoicesZero} zeroRowIndex={3} currency={currency} />
              <Section title={`${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المصروفات والمدخلات الأخرى (ضريبة)`} titleEn={`${selectedTax?.labelEn ?? "VAT"} on Expenses and all other Inputs (Tax)`}    total={p_tax_net}  rows={purchasesTaxRows}  isAr={isAr} type="purchases" invoices={pMerged} invoicesStandard={pInvoicesStandard} invoicesZero={pInvoicesZero} zeroRowIndex={3} currency={currency} />

              {/* ── Net VAT Due ── */}
              <div style={{background:"#fff",borderRadius:6,border:"1px solid #d1d5db",overflow:"hidden"}}>
                <div style={{display:"flex",alignItems:"center",gap:8,padding:"11px 0",paddingInlineStart:18,paddingInlineEnd:Q_ZONE,background:"#e8edf2",borderBottom:"1px solid #d1d5db"}}>
                  <span style={{flex:1,minWidth:0,fontWeight:700,fontSize:13,color:"#0f172a"}}>{isAr?"صافي ضريبة القيمة المضافة المستحقة":"Net VAT Due"}</span>
                  <NetNum value={net_vat_due} color={net_vat_due!==0?"#0f172a":"#94a3b8"} />
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8,padding:"9px 0",paddingInlineStart:36,paddingInlineEnd:Q_ZONE,borderBottom:"1px solid #e8edf2"}}>
                  <span style={{flex:1,minWidth:0,fontSize:12,color:"#334155"}}>{isAr?"إجمالي قيمة الضريبة المستحقة للفترة":"Total value of due tax for the period"}</span>
                  <NetNum value={s_tax_net} color={s_tax_net!==0?"#0f172a":"#94a3b8"} />
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8,padding:"9px 0",paddingInlineStart:36,paddingInlineEnd:Q_ZONE,borderBottom:"1px solid #e8edf2"}}>
                  <span style={{flex:1,minWidth:0,fontSize:12,color:"#334155"}}>{isAr?"إجمالي قيمة الضريبة القابلة للاسترداد للفترة":"Total value of recoverable tax for the period"}</span>
                  <NetNum value={p_tax_net} color={p_tax_net!==0?"#16a34a":"#94a3b8"} />
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8,padding:"9px 0",paddingInlineStart:36,paddingInlineEnd:Q_ZONE}}>
                  <span style={{flex:1,minWidth:0,fontSize:12,color:"#334155",fontWeight:600}}>{isAr?"صافي ضريبة القيمة المضافة المستحقة (أو المستردة) للفترة":"Net VAT due (or reclaimed) for the period"}</span>
                  <NetNum value={net_vat_due} color={net_vat_due>0?"#2563eb":net_vat_due<0?"#16a34a":"#94a3b8"} />
                </div>
              </div>
            </div>
          )}

          {!loading && !data && !error && (
            <div style={{textAlign:"center",color:"#64748b",padding:60,fontSize:14}}>
              {isAr
                ?(isCustom?"اختر التواريخ ثم اضغط «إعداد التقرير»":"اختر نوع الضريبة والفترة الزمنية لعرض التقرير")
                :(isCustom?"Select dates then click «Generate Report»":"Select tax type and period to view the report")}
            </div>
          )}

          {/* ── Footer دايماً في الأسفل ── */}
          <ReportFooter isAr={isAr} isPrint={false} />
        </div>
      </div>

      {/* ── Zatca Filing Modal ── */}
      {showFilingModal && (
        <ZatcaFilingModal
          isAr={isAr}
          dateRange={dateRange}
          tenantId={getTenantId()}
          companyId={getCompanyId()}
          salesInvoices={sInvStandardArr}
          purchasesInvoices={pInvStandardArr}
          onClose={()=>setShowFilingModal(false)}
          onSuccess={()=>{ setShowFilingModal(false); setFilingRefreshKey(k=>k+1); }}
          periodLabel={periodLabel}
          salesData={data}
          purchasesData={purchasesData}
          salesSummary={{
            sectionTitle:  isAr ? `${selectedTax?.labelAr ?? "ضريبة القيمة المضافة"} على المبيعات والمخرجات الأخرى (أساسي)` : `${selectedTax?.labelEn ?? "VAT"} on Sales and all other Outputs (Base)`,
            sectionTotal:  s_net,
            row1Label:     isAr ? salesBaseRows[0]?.label : salesBaseRows[0]?.labelEn,
            row1Value:     s_standard,
          }}
        />
      )}
    </>
  );
}